// Çoklu dil desteği - Translations
export const translations = {
  tr: {
    // Genel
    app_name: "KaanGPT",
    hello: "Merhaba",
    loading: "Yükleniyor...",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    close: "Kapat",
    confirm: "Onayla",
    search: "Ara",
    add: "Ekle",
    send: "Gönder",
    copy: "Kopyala",
    copied: "Kopyalandı",
    download: "İndir",
    upload: "Yükle",
    yes: "Evet",
    no: "Hayır",
    or: "veya",
    
    // Auth
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış Yap",
    email: "E-posta",
    password: "Şifre",
    name: "İsim",
    forgot_password: "Şifremi Unuttum",
    dont_have_account: "Hesabınız yok mu?",
    already_have_account: "Zaten hesabınız var mı?",
    
    // Sidebar
    chats: "Sohbetler",
    new_chat: "Yeni",
    new_chat_title: "Yeni Sohbet",
    search_chats: "Sohbet ara...",
    no_chats: "Henüz sohbet yok",
    no_results: "Sonuç bulunamadı",
    archive: "Arşiv",
    smart_assistant: "Akıllı Asistan",
    all_features_login: "Tüm özelliklere erişmek için giriş yapın",
    
    // Welcome Screen
    welcome: "Merhaba!",
    welcome_user: "Merhaba, {name}!",
    select_assistant: "Bir asistan seçin ve sohbete başlayın",
    remaining_free: "Kalan ücretsiz soru",
    unlimited_access: "Sınırsız soru sormak için",
    daily_limit_reached: "Bugünlük ücretsiz soru sorma hakkınız bitmiştir",
    create_account: "Sınırsız soru sormak için hesap oluşturun",
    
    // Chat
    chat: "Sohbet",
    image: "Görsel",
    file: "Dosya",
    voice_on: "Ses Açık",
    voice_off: "Ses Kapalı",
    type_message: "Bir mesaj yazın...",
    ask_question: "Soru sorun...",
    ask_assistant: "{name}'a bir şey sorun...",
    image_ready: "Görsel analiz için hazır",
    generating: "Oluşturuluyor...",
    thinking: "Düşünüyor...",
    stop: "Durdur",
    regenerate: "Yeniden Oluştur",
    listening: "DİNLİYORUM",
    stop_recording: "Kaydı Durdur",
    voice_command: "Sesli Komut",
    speak_now: "Konuşun...",
    voice_recognition_failed: "Ses tanıma başarısız",
    voice_recognized: "Ses tanındı",
    voice_not_understood: "Ses algılandı ancak metin çözümlenemedi",
    microphone_denied: "Mikrofon erişimi reddedildi",
    
    // Assistants
    assistant_kaan: "Kaan",
    assistant_kaan_desc: "Analitik ve pratik çözümlerle size yardımcı olurum.",
    assistant_defne: "Defne",
    assistant_defne_desc: "Empatik ve anlayışlı bir yaklaşımla size yardımcı olurum.",
    new_assistant: "Yeni",
    create_assistant: "Asistan Oluştur",
    chatting_with: "{name} ile sohbet",
    
    // Chat Actions
    rename: "Yeniden Adlandır",
    share: "Paylaş",
    export: "Dışa Aktar",
    archive_chat: "Arşivle",
    unarchive: "Arşivden Çıkar",
    delete_chat: "Sil",
    share_link: "Paylaşım Linki",
    link_copied: "Link kopyalandı!",
    
    // Settings
    settings: "Ayarlar",
    profile: "Profil",
    appearance: "Görünüm",
    notifications: "Bildirimler",
    language: "Dil",
    security: "Güvenlik",
    
    // Profile
    profile_info: "Profil Bilgileri",
    account_type: "Hesap Türü",
    free: "Ücretsiz",
    admin: "Admin",
    premium: "Premium",
    
    // Appearance
    theme: "Tema",
    theme_dark: "Koyu",
    theme_light: "Açık",
    theme_system: "Sistem",
    font_size: "Yazı Boyutu",
    font_small: "Küçük",
    font_medium: "Normal",
    font_large: "Büyük",
    auto_correct: "Otomatik Düzeltme",
    auto_correct_desc: "AI ile yazım hatalarını düzelt",
    
    // Notifications
    notification_settings: "Bildirim Ayarları",
    sound_notifications: "Ses Bildirimleri",
    sound_notifications_desc: "Yeni mesajlarda ses çal",
    desktop_notifications: "Masaüstü Bildirimleri",
    desktop_notifications_desc: "Tarayıcı bildirimleri al",
    email_notifications: "E-posta Bildirimleri",
    email_notifications_desc: "Önemli güncellemeler için e-posta al",
    
    // Archive
    archived_chats: "Arşivlenmiş Sohbetler",
    no_archived: "Arşivlenmiş sohbet yok",
    
    // Language
    language_settings: "Dil Ayarları",
    app_language: "Uygulama Dili",
    language_note: "Not: Dil değişikliği hemen uygulanır.",
    
    // Security
    change_password: "Şifre Değiştir",
    current_password: "Mevcut Şifre",
    new_password: "Yeni Şifre",
    confirm_password: "Yeni Şifre (Tekrar)",
    
    // Feedback
    was_helpful: "Bu cevap faydalı mıydı?",
    feedback_saved: "Geri bildiriminiz kaydedildi",
    why_unhappy: "Neden memnun kalmadınız?",
    add_comment: "Eklemek istediğiniz bir şey var mı?",
    feedback_wrong: "Yanlış bilgi",
    feedback_incomplete: "Eksik cevap",
    feedback_unclear: "Anlaşılmaz",
    feedback_slow: "Çok yavaş",
    feedback_irrelevant: "Alakasız",
    feedback_other: "Diğer",
    
    // Credits & Subscription
    credits: "Kredi",
    subscription: "Abonelik",
    subscribe: "Abone Ol",
    buy_credits: "Kredi Satın Al",
    transfer_credits: "Kredi Transfer Et",
    
    // Admin
    admin_panel: "Admin Paneli",
    analytics: "Analiz",
    users: "Kullanıcılar",
    
    // Modes
    mode_chat: "Sohbet",
    mode_image: "Görsel",
    mode_file: "Dosya",
    
    // Image
    create_image: "Görsel Oluştur",
    describe_image: "Oluşturmak istediğiniz görseli tanımlayın...",
    image_analysis: "Görsel Analiz",
    
    // File
    select_file: "Dosya Seç",
    ask_about_file: "Dosya hakkında soru sorun...",
    file_analysis: "Dosya Analizi",
    
    // Errors
    error_occurred: "Bir hata oluştu",
    try_again: "Tekrar deneyin",
    connection_error: "Bağlantı hatası",
    
    // Success
    saved_successfully: "Başarıyla kaydedildi",
    deleted_successfully: "Başarıyla silindi",
    
    // Confirm dialogs
    confirm_delete: "Silmek istediğinizden emin misiniz?",
    confirm_logout: "Çıkış yapmak istediğinizden emin misiniz?",
    confirm_archive: "Arşivlemek istediğinizden emin misiniz?",
    delete_message_title: "Mesajı Sil",
    delete_message_confirm: "Bu mesajı silmek istediğinizden emin misiniz?",
    delete_chat_title: "Sohbeti Sil",
    delete_chat_confirm: "Bu sohbeti silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    clear_memory_title: "Hafızayı Temizle",
    clear_memory_message: "Tüm hafıza silinecek. Bu işlem geri alınamaz. Emin misiniz?",
    cancel_subscription_title: "Abonelik İptali",
    cancel_subscription_message: "Aboneliğinizi iptal etmek istediğinizden emin misiniz?",
    yes_delete: "Evet, Sil",
    yes_clear: "Evet, Temizle",
    yes_cancel: "Evet, İptal Et",
    no_back: "Vazgeç",
    cancel: "İptal",
    delete: "Sil",
    clear_failed: "Temizlenemedi",
    cancel_failed: "İptal işlemi başarısız",
    subscription_cancelled: "Abonelik iptal edildi",
    
    // Memory
    memory: "Hafıza",
    ai_memory: "AI Hafızası",
    memory_desc: "AI'ın sizin hakkınızda hatırladıkları",
    
    // Message Actions
    like: "Beğen",
    dislike: "Beğenme",
    listen: "Dinle"
  },
  
  en: {
    // General
    app_name: "KaanGPT",
    hello: "Hello",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    search: "Search",
    add: "Add",
    send: "Send",
    copy: "Copy",
    copied: "Copied",
    download: "Download",
    upload: "Upload",
    yes: "Yes",
    no: "No",
    or: "or",
    
    // Auth
    login: "Login",
    register: "Sign Up",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Name",
    forgot_password: "Forgot Password",
    dont_have_account: "Don't have an account?",
    already_have_account: "Already have an account?",
    
    // Sidebar
    chats: "Chats",
    new_chat: "New",
    new_chat_title: "New Chat",
    search_chats: "Search chats...",
    no_chats: "No chats yet",
    no_results: "No results found",
    archive: "Archive",
    smart_assistant: "Smart Assistant",
    all_features_login: "Login for all features",
    
    // Welcome Screen
    welcome: "Hello!",
    welcome_user: "Hello, {name}!",
    select_assistant: "Select an assistant and start chatting",
    remaining_free: "Remaining free questions",
    unlimited_access: "For unlimited questions",
    daily_limit_reached: "You've reached your daily free question limit",
    create_account: "Create an account for unlimited questions",
    
    // Chat
    chat: "Chat",
    image: "Image",
    file: "File",
    voice_on: "Voice On",
    voice_off: "Voice Off",
    type_message: "Type a message...",
    ask_question: "Ask a question...",
    ask_assistant: "Ask {name} something...",
    image_ready: "Image ready for analysis",
    generating: "Generating...",
    thinking: "Thinking...",
    stop: "Stop",
    regenerate: "Regenerate",
    listening: "LISTENING",
    stop_recording: "Stop Recording",
    voice_command: "Voice Command",
    speak_now: "Speak now...",
    voice_recognition_failed: "Voice recognition failed",
    voice_recognized: "Voice recognized",
    voice_not_understood: "Audio detected but could not be transcribed",
    microphone_denied: "Microphone access denied",
    
    // Assistants
    assistant_kaan: "Kaan",
    assistant_kaan_desc: "I help you with analytical and practical solutions.",
    assistant_defne: "Defne",
    assistant_defne_desc: "I help you with an empathetic and understanding approach.",
    new_assistant: "New",
    create_assistant: "Create Assistant",
    chatting_with: "Chatting with {name}",
    
    // Chat Actions
    rename: "Rename",
    share: "Share",
    export: "Export",
    archive_chat: "Archive",
    unarchive: "Unarchive",
    delete_chat: "Delete",
    share_link: "Share Link",
    link_copied: "Link copied!",
    
    // Settings
    settings: "Settings",
    profile: "Profile",
    appearance: "Appearance",
    notifications: "Notifications",
    language: "Language",
    security: "Security",
    
    // Profile
    profile_info: "Profile Information",
    account_type: "Account Type",
    free: "Free",
    admin: "Admin",
    premium: "Premium",
    
    // Appearance
    theme: "Theme",
    theme_dark: "Dark",
    theme_light: "Light",
    theme_system: "System",
    font_size: "Font Size",
    font_small: "Small",
    font_medium: "Medium",
    font_large: "Large",
    auto_correct: "Auto Correct",
    auto_correct_desc: "Fix spelling errors with AI",
    
    // Notifications
    notification_settings: "Notification Settings",
    sound_notifications: "Sound Notifications",
    sound_notifications_desc: "Play sound for new messages",
    desktop_notifications: "Desktop Notifications",
    desktop_notifications_desc: "Receive browser notifications",
    email_notifications: "Email Notifications",
    email_notifications_desc: "Receive emails for important updates",
    
    // Archive
    archived_chats: "Archived Chats",
    no_archived: "No archived chats",
    
    // Language
    language_settings: "Language Settings",
    app_language: "App Language",
    language_note: "Note: Language change applies immediately.",
    
    // Security
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    
    // Feedback
    was_helpful: "Was this response helpful?",
    feedback_saved: "Your feedback has been saved",
    why_unhappy: "Why were you unhappy?",
    add_comment: "Any additional comments?",
    feedback_wrong: "Wrong information",
    feedback_incomplete: "Incomplete answer",
    feedback_unclear: "Unclear",
    feedback_slow: "Too slow",
    feedback_irrelevant: "Irrelevant",
    feedback_other: "Other",
    
    // Credits & Subscription
    credits: "Credits",
    subscription: "Subscription",
    subscribe: "Subscribe",
    buy_credits: "Buy Credits",
    transfer_credits: "Transfer Credits",
    
    // Admin
    admin_panel: "Admin Panel",
    analytics: "Analytics",
    users: "Users",
    
    // Modes
    mode_chat: "Chat",
    mode_image: "Image",
    mode_file: "File",
    
    // Image
    create_image: "Create Image",
    describe_image: "Describe the image you want to create...",
    image_analysis: "Image Analysis",
    
    // File
    select_file: "Select File",
    ask_about_file: "Ask about the file...",
    file_analysis: "File Analysis",
    
    // Errors
    error_occurred: "An error occurred",
    try_again: "Try again",
    connection_error: "Connection error",
    
    // Success
    saved_successfully: "Saved successfully",
    deleted_successfully: "Deleted successfully",
    
    // Confirm dialogs
    confirm_delete: "Are you sure you want to delete?",
    confirm_logout: "Are you sure you want to logout?",
    confirm_archive: "Are you sure you want to archive?",
    delete_message_title: "Delete Message",
    delete_message_confirm: "Are you sure you want to delete this message?",
    delete_chat_title: "Delete Chat",
    delete_chat_confirm: "Are you sure you want to delete this chat? This action cannot be undone.",
    clear_memory_title: "Clear Memory",
    clear_memory_message: "All memory will be deleted. This action cannot be undone. Are you sure?",
    cancel_subscription_title: "Cancel Subscription",
    cancel_subscription_message: "Are you sure you want to cancel your subscription?",
    yes_delete: "Yes, Delete",
    yes_clear: "Yes, Clear",
    yes_cancel: "Yes, Cancel",
    no_back: "Go Back",
    cancel: "Cancel",
    delete: "Delete",
    clear_failed: "Could not clear",
    cancel_failed: "Cancellation failed",
    subscription_cancelled: "Subscription cancelled",
    
    // Memory
    memory: "Memory",
    ai_memory: "AI Memory",
    memory_desc: "What AI remembers about you",
    
    // Message Actions
    like: "Like",
    dislike: "Dislike",
    listen: "Listen"
  },
  
  de: {
    // General
    app_name: "KaanGPT",
    hello: "Hallo",
    loading: "Wird geladen...",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    edit: "Bearbeiten",
    close: "Schließen",
    confirm: "Bestätigen",
    search: "Suchen",
    add: "Hinzufügen",
    send: "Senden",
    copy: "Kopieren",
    copied: "Kopiert",
    download: "Herunterladen",
    upload: "Hochladen",
    yes: "Ja",
    no: "Nein",
    or: "oder",
    free: "Kostenlos",
    admin: "Admin",
    premium: "Premium",
    
    // Auth
    login: "Anmelden",
    register: "Registrieren",
    logout: "Abmelden",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    dont_have_account: "Kein Konto?",
    already_have_account: "Bereits registriert?",
    
    // Sidebar
    chats: "Chats",
    new_chat: "Neu",
    new_chat_title: "Neuer Chat",
    search_chats: "Chats suchen...",
    no_chats: "Noch keine Chats",
    no_results: "Keine Ergebnisse",
    archive: "Archiv",
    smart_assistant: "Intelligenter Assistent",
    
    // Welcome
    welcome: "Hallo!",
    welcome_user: "Hallo, {name}!",
    select_assistant: "Wählen Sie einen Assistenten und starten Sie den Chat",
    remaining_free: "Verbleibende kostenlose Fragen",
    unlimited_access: "Für unbegrenzte Fragen",
    daily_limit_reached: "Tageslimit erreicht",
    create_account: "Erstellen Sie ein Konto für unbegrenzte Fragen",
    
    // Chat
    chat: "Chat",
    image: "Bild",
    file: "Datei",
    voice_on: "Ton An",
    voice_off: "Ton Aus",
    type_message: "Nachricht eingeben...",
    thinking: "Denkt nach...",
    ask_question: "Frage stellen...",
    image_ready: "Bild zur Analyse bereit",
    describe_image: "Beschreiben Sie das gewünschte Bild...",
    select_file: "Datei auswählen",
    ask_about_file: "Frage zur Datei stellen...",
    listening: "HÖRE ZU",
    stop_recording: "Aufnahme stoppen",
    voice_command: "Sprachbefehl",
    speak_now: "Jetzt sprechen...",
    voice_recognition_failed: "Spracherkennung fehlgeschlagen",
    voice_recognized: "Sprache erkannt",
    voice_not_understood: "Audio erkannt, aber konnte nicht transkribiert werden",
    
    // Assistants
    assistant_kaan: "Kaan",
    assistant_kaan_desc: "Ich helfe mit analytischen und praktischen Lösungen.",
    assistant_defne: "Defne",
    assistant_defne_desc: "Ich helfe mit einem einfühlsamen Ansatz.",
    new_assistant: "Neu",
    chatting_with: "Chat mit {name}",
    create_assistant: "Assistent erstellen",
    
    // Actions
    rename: "Umbenennen",
    share: "Teilen",
    export: "Exportieren",
    archive_chat: "Archivieren",
    unarchive: "Wiederherstellen",
    delete_chat: "Löschen",
    
    // Settings
    settings: "Einstellungen",
    profile: "Profil",
    appearance: "Darstellung",
    notifications: "Benachrichtigungen",
    language: "Sprache",
    security: "Sicherheit",
    
    // Profile
    profile_info: "Profilinformationen",
    account_type: "Kontotyp",
    
    // Appearance
    theme: "Design",
    theme_dark: "Dunkel",
    theme_light: "Hell",
    theme_system: "System",
    font_size: "Schriftgröße",
    font_small: "Klein",
    font_medium: "Normal",
    font_large: "Groß",
    auto_correct: "Autokorrektur",
    auto_correct_desc: "Rechtschreibfehler mit KI korrigieren",
    
    // Notifications
    notification_settings: "Benachrichtigungseinstellungen",
    sound_notifications: "Tonbenachrichtigungen",
    sound_notifications_desc: "Ton bei neuen Nachrichten",
    desktop_notifications: "Desktop-Benachrichtigungen",
    desktop_notifications_desc: "Browser-Benachrichtigungen",
    email_notifications: "E-Mail-Benachrichtigungen",
    email_notifications_desc: "E-Mails für wichtige Updates",
    
    // Archive
    archived_chats: "Archivierte Chats",
    no_archived: "Keine archivierten Chats",
    
    // Language
    language_settings: "Spracheinstellungen",
    app_language: "App-Sprache",
    language_note: "Hinweis: Sprachänderung wird sofort angewendet.",
    
    // Security
    change_password: "Passwort ändern",
    current_password: "Aktuelles Passwort",
    new_password: "Neues Passwort",
    confirm_password: "Passwort bestätigen",
    
    // Feedback
    was_helpful: "War diese Antwort hilfreich?",
    feedback_saved: "Feedback gespeichert",
    
    // Credits
    credits: "Credits",
    subscription: "Abonnement",
    subscribe: "Abonnieren",
    buy_credits: "Credits kaufen",
    transfer_credits: "Credits übertragen",
    
    // Modes
    mode_chat: "Chat",
    mode_image: "Bild",
    mode_file: "Datei",
    
    // Errors
    error_occurred: "Ein Fehler ist aufgetreten",
    try_again: "Erneut versuchen",
    confirm_delete: "Sind Sie sicher, dass Sie löschen möchten?",
    
    // Confirm dialogs
    delete_message_title: "Nachricht löschen",
    delete_message_confirm: "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
    delete_chat_title: "Chat löschen",
    delete_chat_confirm: "Sind Sie sicher, dass Sie diesen Chat löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    yes_delete: "Ja, löschen",
    yes_clear: "Ja, leeren",
    yes_cancel: "Ja, abbrechen",
    no_back: "Zurück",
    deleted_successfully: "Erfolgreich gelöscht",
    feedback_saved: "Feedback gespeichert",
    like: "Gefällt mir",
    dislike: "Gefällt mir nicht",
    listen: "Anhören",
    
    // Memory
    memory: "Speicher",
    ai_memory: "KI-Speicher",
    memory_desc: "Was die KI über Sie weiß"
  },
  
  fr: {
    // General
    app_name: "KaanGPT",
    hello: "Bonjour",
    loading: "Chargement...",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    close: "Fermer",
    confirm: "Confirmer",
    search: "Rechercher",
    add: "Ajouter",
    send: "Envoyer",
    copy: "Copier",
    copied: "Copié",
    download: "Télécharger",
    upload: "Importer",
    yes: "Oui",
    no: "Non",
    or: "ou",
    free: "Gratuit",
    admin: "Admin",
    premium: "Premium",
    
    // Auth
    login: "Connexion",
    register: "S'inscrire",
    logout: "Déconnexion",
    email: "E-mail",
    password: "Mot de passe",
    name: "Nom",
    dont_have_account: "Pas de compte?",
    already_have_account: "Déjà inscrit?",
    
    // Sidebar
    chats: "Conversations",
    new_chat: "Nouveau",
    new_chat_title: "Nouvelle conversation",
    search_chats: "Rechercher...",
    no_chats: "Aucune conversation",
    no_results: "Aucun résultat",
    archive: "Archives",
    smart_assistant: "Assistant Intelligent",
    
    // Welcome
    welcome: "Bonjour!",
    welcome_user: "Bonjour, {name}!",
    select_assistant: "Sélectionnez un assistant et commencez à discuter",
    remaining_free: "Questions gratuites restantes",
    unlimited_access: "Pour des questions illimitées",
    daily_limit_reached: "Limite quotidienne atteinte",
    create_account: "Créez un compte pour des questions illimitées",
    
    // Chat
    chat: "Discussion",
    image: "Image",
    file: "Fichier",
    voice_on: "Son Activé",
    voice_off: "Son Désactivé",
    type_message: "Tapez un message...",
    thinking: "Réflexion...",
    ask_question: "Posez une question...",
    image_ready: "Image prête pour l'analyse",
    describe_image: "Décrivez l'image souhaitée...",
    select_file: "Sélectionner un fichier",
    ask_about_file: "Question sur le fichier...",
    listening: "J'ÉCOUTE",
    stop_recording: "Arrêter l'enregistrement",
    voice_command: "Commande vocale",
    speak_now: "Parlez maintenant...",
    voice_recognition_failed: "Reconnaissance vocale échouée",
    voice_recognized: "Voix reconnue",
    voice_not_understood: "Audio détecté mais impossible à transcrire",
    
    // Assistants
    assistant_kaan: "Kaan",
    assistant_kaan_desc: "Je vous aide avec des solutions analytiques et pratiques.",
    assistant_defne: "Defne",
    assistant_defne_desc: "Je vous aide avec une approche empathique.",
    new_assistant: "Nouveau",
    chatting_with: "Discussion avec {name}",
    create_assistant: "Créer un assistant",
    
    // Actions
    rename: "Renommer",
    share: "Partager",
    export: "Exporter",
    archive_chat: "Archiver",
    unarchive: "Désarchiver",
    delete_chat: "Supprimer",
    
    // Settings
    settings: "Paramètres",
    profile: "Profil",
    appearance: "Apparence",
    notifications: "Notifications",
    language: "Langue",
    security: "Sécurité",
    
    // Profile
    profile_info: "Informations du profil",
    account_type: "Type de compte",
    
    // Appearance
    theme: "Thème",
    theme_dark: "Sombre",
    theme_light: "Clair",
    theme_system: "Système",
    font_size: "Taille de police",
    font_small: "Petit",
    font_medium: "Normal",
    font_large: "Grand",
    auto_correct: "Correction auto",
    auto_correct_desc: "Corriger les fautes avec l'IA",
    
    // Notifications
    notification_settings: "Paramètres de notification",
    sound_notifications: "Notifications sonores",
    sound_notifications_desc: "Son pour les nouveaux messages",
    desktop_notifications: "Notifications bureau",
    desktop_notifications_desc: "Notifications navigateur",
    email_notifications: "Notifications e-mail",
    email_notifications_desc: "E-mails pour mises à jour importantes",
    
    // Archive
    archived_chats: "Conversations archivées",
    no_archived: "Aucune archive",
    
    // Language
    language_settings: "Paramètres de langue",
    app_language: "Langue de l'app",
    language_note: "Note: Le changement de langue s'applique immédiatement.",
    
    // Security
    change_password: "Changer le mot de passe",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    
    // Feedback
    was_helpful: "Cette réponse était-elle utile?",
    feedback_saved: "Commentaire enregistré",
    
    // Credits
    credits: "Crédits",
    subscription: "Abonnement",
    subscribe: "S'abonner",
    buy_credits: "Acheter des crédits",
    transfer_credits: "Transférer des crédits",
    
    // Modes
    mode_chat: "Discussion",
    mode_image: "Image",
    mode_file: "Fichier",
    
    // Errors
    error_occurred: "Une erreur s'est produite",
    try_again: "Réessayer",
    confirm_delete: "Êtes-vous sûr de vouloir supprimer?",
    
    // Confirm dialogs
    delete_message_title: "Supprimer le message",
    delete_message_confirm: "Êtes-vous sûr de vouloir supprimer ce message?",
    delete_chat_title: "Supprimer la conversation",
    delete_chat_confirm: "Êtes-vous sûr de vouloir supprimer cette conversation? Cette action est irréversible.",
    yes_delete: "Oui, supprimer",
    yes_clear: "Oui, effacer",
    yes_cancel: "Oui, annuler",
    no_back: "Retour",
    deleted_successfully: "Supprimé avec succès",
    feedback_saved: "Commentaire enregistré",
    like: "J'aime",
    dislike: "Je n'aime pas",
    listen: "Écouter",
    
    // Memory
    memory: "Mémoire",
    ai_memory: "Mémoire IA",
    memory_desc: "Ce que l'IA sait de vous"
  },
  
  es: {
    // General
    app_name: "KaanGPT",
    hello: "Hola",
    loading: "Cargando...",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    close: "Cerrar",
    confirm: "Confirmar",
    search: "Buscar",
    add: "Añadir",
    send: "Enviar",
    copy: "Copiar",
    copied: "Copiado",
    download: "Descargar",
    upload: "Subir",
    yes: "Sí",
    no: "No",
    or: "o",
    free: "Gratis",
    admin: "Admin",
    premium: "Premium",
    
    // Auth
    login: "Iniciar sesión",
    register: "Registrarse",
    logout: "Cerrar sesión",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre",
    dont_have_account: "¿No tienes cuenta?",
    already_have_account: "¿Ya tienes cuenta?",
    
    // Sidebar
    chats: "Chats",
    new_chat: "Nuevo",
    new_chat_title: "Nuevo chat",
    search_chats: "Buscar chats...",
    no_chats: "Sin chats",
    no_results: "Sin resultados",
    archive: "Archivo",
    smart_assistant: "Asistente Inteligente",
    
    // Welcome
    welcome: "¡Hola!",
    welcome_user: "¡Hola, {name}!",
    select_assistant: "Selecciona un asistente y empieza a chatear",
    remaining_free: "Preguntas gratuitas restantes",
    unlimited_access: "Para preguntas ilimitadas",
    daily_limit_reached: "Límite diario alcanzado",
    create_account: "Crea una cuenta para preguntas ilimitadas",
    
    // Chat
    chat: "Chat",
    image: "Imagen",
    file: "Archivo",
    voice_on: "Voz Activada",
    voice_off: "Voz Desactivada",
    type_message: "Escribe un mensaje...",
    thinking: "Pensando...",
    ask_question: "Haz una pregunta...",
    image_ready: "Imagen lista para análisis",
    describe_image: "Describe la imagen que deseas...",
    select_file: "Seleccionar archivo",
    ask_about_file: "Pregunta sobre el archivo...",
    listening: "ESCUCHANDO",
    stop_recording: "Detener grabación",
    voice_command: "Comando de voz",
    speak_now: "Habla ahora...",
    voice_recognition_failed: "Reconocimiento de voz fallido",
    voice_recognized: "Voz reconocida",
    voice_not_understood: "Audio detectado pero no se pudo transcribir",
    
    // Assistants
    assistant_kaan: "Kaan",
    assistant_kaan_desc: "Te ayudo con soluciones analíticas y prácticas.",
    assistant_defne: "Defne",
    assistant_defne_desc: "Te ayudo con un enfoque empático.",
    new_assistant: "Nuevo",
    chatting_with: "Chateando con {name}",
    create_assistant: "Crear asistente",
    
    // Actions
    rename: "Renombrar",
    share: "Compartir",
    export: "Exportar",
    archive_chat: "Archivar",
    unarchive: "Desarchivar",
    delete_chat: "Eliminar",
    
    // Settings
    settings: "Ajustes",
    profile: "Perfil",
    appearance: "Apariencia",
    notifications: "Notificaciones",
    language: "Idioma",
    security: "Seguridad",
    
    // Profile
    profile_info: "Información del perfil",
    account_type: "Tipo de cuenta",
    
    // Appearance
    theme: "Tema",
    theme_dark: "Oscuro",
    theme_light: "Claro",
    theme_system: "Sistema",
    font_size: "Tamaño de fuente",
    font_small: "Pequeño",
    font_medium: "Normal",
    font_large: "Grande",
    auto_correct: "Corrección automática",
    auto_correct_desc: "Corregir errores con IA",
    
    // Notifications
    notification_settings: "Ajustes de notificaciones",
    sound_notifications: "Notificaciones de sonido",
    sound_notifications_desc: "Sonido para nuevos mensajes",
    desktop_notifications: "Notificaciones de escritorio",
    desktop_notifications_desc: "Notificaciones del navegador",
    email_notifications: "Notificaciones por email",
    email_notifications_desc: "Emails para actualizaciones importantes",
    
    // Archive
    archived_chats: "Chats archivados",
    no_archived: "Sin archivos",
    
    // Language
    language_settings: "Ajustes de idioma",
    app_language: "Idioma de la app",
    language_note: "Nota: El cambio de idioma se aplica inmediatamente.",
    
    // Security
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    confirm_password: "Confirmar contraseña",
    
    // Feedback
    was_helpful: "¿Fue útil esta respuesta?",
    feedback_saved: "Comentario guardado",
    
    // Credits
    credits: "Créditos",
    subscription: "Suscripción",
    subscribe: "Suscribirse",
    buy_credits: "Comprar créditos",
    transfer_credits: "Transferir créditos",
    
    // Modes
    mode_chat: "Chat",
    mode_image: "Imagen",
    mode_file: "Archivo",
    
    // Errors
    error_occurred: "Ocurrió un error",
    try_again: "Intentar de nuevo",
    confirm_delete: "¿Seguro que quieres eliminar?",
    
    // Confirm dialogs
    delete_message_title: "Eliminar mensaje",
    delete_message_confirm: "¿Estás seguro de que quieres eliminar este mensaje?",
    delete_chat_title: "Eliminar chat",
    delete_chat_confirm: "¿Estás seguro de que quieres eliminar este chat? Esta acción no se puede deshacer.",
    yes_delete: "Sí, eliminar",
    yes_clear: "Sí, limpiar",
    yes_cancel: "Sí, cancelar",
    no_back: "Volver",
    deleted_successfully: "Eliminado con éxito",
    feedback_saved: "Comentario guardado",
    like: "Me gusta",
    dislike: "No me gusta",
    listen: "Escuchar",
    
    // Memory
    memory: "Memoria",
    ai_memory: "Memoria IA",
    memory_desc: "Lo que la IA sabe de ti"
  },
  
  ar: {
    // General
    app_name: "KaanGPT",
    hello: "مرحبا",
    loading: "جار التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    close: "إغلاق",
    confirm: "تأكيد",
    search: "بحث",
    add: "إضافة",
    send: "إرسال",
    copy: "نسخ",
    copied: "تم النسخ",
    download: "تحميل",
    upload: "رفع",
    yes: "نعم",
    no: "لا",
    or: "أو",
    
    // Auth
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم",
    
    // Sidebar
    chats: "المحادثات",
    new_chat: "جديد",
    new_chat_title: "محادثة جديدة",
    search_chats: "بحث في المحادثات...",
    no_chats: "لا توجد محادثات",
    no_results: "لا توجد نتائج",
    archive: "الأرشيف",
    smart_assistant: "المساعد الذكي",
    
    // Welcome
    welcome: "مرحبا!",
    welcome_user: "مرحبا، {name}!",
    select_assistant: "اختر مساعد وابدأ المحادثة",
    
    // Chat
    chat: "محادثة",
    image: "صورة",
    file: "ملف",
    voice_on: "الصوت مفعل",
    voice_off: "الصوت مغلق",
    type_message: "اكتب رسالة...",
    thinking: "يفكر...",
    listening: "أستمع",
    stop_recording: "إيقاف التسجيل",
    voice_command: "أمر صوتي",
    speak_now: "تحدث الآن...",
    voice_recognition_failed: "فشل التعرف على الصوت",
    voice_recognized: "تم التعرف على الصوت",
    voice_not_understood: "تم الكشف عن الصوت ولكن لم يتم تحويله إلى نص",
    
    // Assistants
    new_assistant: "جديد",
    chatting_with: "محادثة مع {name}",
    
    // Actions
    rename: "إعادة تسمية",
    share: "مشاركة",
    export: "تصدير",
    archive_chat: "أرشفة",
    unarchive: "إلغاء الأرشفة",
    delete_chat: "حذف",
    
    // Settings
    settings: "الإعدادات",
    profile: "الملف الشخصي",
    appearance: "المظهر",
    notifications: "الإشعارات",
    language: "اللغة",
    security: "الأمان",
    
    // Profile
    profile_info: "معلومات الملف الشخصي",
    account_type: "نوع الحساب",
    
    // Appearance
    theme: "السمة",
    theme_dark: "داكن",
    theme_light: "فاتح",
    theme_system: "النظام",
    font_size: "حجم الخط",
    font_small: "صغير",
    font_medium: "متوسط",
    font_large: "كبير",
    auto_correct: "التصحيح التلقائي",
    auto_correct_desc: "تصحيح الأخطاء الإملائية بالذكاء الاصطناعي",
    
    // Language
    language_settings: "إعدادات اللغة",
    app_language: "لغة التطبيق",
    language_note: "ملاحظة: يتم تطبيق تغيير اللغة فوراً.",
    
    // Security
    change_password: "تغيير كلمة المرور",
    current_password: "كلمة المرور الحالية",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    
    // Feedback
    was_helpful: "هل كانت هذه الإجابة مفيدة؟",
    feedback_saved: "تم حفظ ملاحظاتك",
    
    // Credits
    credits: "الرصيد",
    subscription: "الاشتراك",
    
    // Errors
    error_occurred: "حدث خطأ",
    try_again: "حاول مرة أخرى",
    
    // Confirm dialogs
    delete_message_title: "حذف الرسالة",
    delete_message_confirm: "هل أنت متأكد أنك تريد حذف هذه الرسالة؟",
    delete_chat_title: "حذف المحادثة",
    delete_chat_confirm: "هل أنت متأكد أنك تريد حذف هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.",
    yes_delete: "نعم، احذف",
    yes_clear: "نعم، امسح",
    yes_cancel: "نعم، إلغاء",
    no_back: "رجوع",
    deleted_successfully: "تم الحذف بنجاح",
    like: "أعجبني",
    dislike: "لم يعجبني",
    listen: "استمع"
  },
  
  ru: {
    // General
    app_name: "KaanGPT",
    hello: "Привет",
    loading: "Загрузка...",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    edit: "Редактировать",
    close: "Закрыть",
    confirm: "Подтвердить",
    search: "Поиск",
    add: "Добавить",
    send: "Отправить",
    copy: "Копировать",
    copied: "Скопировано",
    download: "Скачать",
    upload: "Загрузить",
    yes: "Да",
    no: "Нет",
    or: "или",
    
    // Auth
    login: "Войти",
    register: "Регистрация",
    logout: "Выйти",
    email: "Эл. почта",
    password: "Пароль",
    name: "Имя",
    
    // Sidebar
    chats: "Чаты",
    new_chat: "Новый",
    new_chat_title: "Новый чат",
    search_chats: "Поиск чатов...",
    no_chats: "Нет чатов",
    no_results: "Ничего не найдено",
    archive: "Архив",
    smart_assistant: "Умный Ассистент",
    
    // Welcome
    welcome: "Привет!",
    welcome_user: "Привет, {name}!",
    select_assistant: "Выберите ассистента и начните общение",
    
    // Chat
    chat: "Чат",
    image: "Изображение",
    file: "Файл",
    voice_on: "Звук Вкл",
    voice_off: "Звук Выкл",
    type_message: "Введите сообщение...",
    thinking: "Думает...",
    listening: "СЛУШАЮ",
    stop_recording: "Остановить запись",
    voice_command: "Голосовая команда",
    speak_now: "Говорите...",
    voice_recognition_failed: "Распознавание голоса не удалось",
    voice_recognized: "Голос распознан",
    voice_not_understood: "Аудио обнаружено, но не удалось распознать",
    
    // Assistants
    new_assistant: "Новый",
    chatting_with: "Чат с {name}",
    
    // Actions
    rename: "Переименовать",
    share: "Поделиться",
    export: "Экспорт",
    archive_chat: "Архивировать",
    unarchive: "Разархивировать",
    delete_chat: "Удалить",
    
    // Settings
    settings: "Настройки",
    profile: "Профиль",
    appearance: "Внешний вид",
    notifications: "Уведомления",
    language: "Язык",
    security: "Безопасность",
    
    // Profile
    profile_info: "Информация профиля",
    account_type: "Тип аккаунта",
    
    // Appearance
    theme: "Тема",
    theme_dark: "Тёмная",
    theme_light: "Светлая",
    theme_system: "Системная",
    font_size: "Размер шрифта",
    font_small: "Маленький",
    font_medium: "Средний",
    font_large: "Большой",
    auto_correct: "Автокоррекция",
    auto_correct_desc: "Исправлять ошибки с помощью ИИ",
    
    // Language
    language_settings: "Настройки языка",
    app_language: "Язык приложения",
    language_note: "Примечание: Изменение языка применяется сразу.",
    
    // Security
    change_password: "Изменить пароль",
    current_password: "Текущий пароль",
    new_password: "Новый пароль",
    confirm_password: "Подтвердите пароль",
    
    // Feedback
    was_helpful: "Был ли этот ответ полезен?",
    feedback_saved: "Отзыв сохранён",
    
    // Credits
    credits: "Кредиты",
    subscription: "Подписка",
    
    // Errors
    error_occurred: "Произошла ошибка",
    try_again: "Попробовать снова",
    
    // Confirm dialogs
    delete_message_title: "Удалить сообщение",
    delete_message_confirm: "Вы уверены, что хотите удалить это сообщение?",
    delete_chat_title: "Удалить чат",
    delete_chat_confirm: "Вы уверены, что хотите удалить этот чат? Это действие нельзя отменить.",
    yes_delete: "Да, удалить",
    yes_clear: "Да, очистить",
    yes_cancel: "Да, отменить",
    no_back: "Назад",
    deleted_successfully: "Успешно удалено",
    like: "Нравится",
    dislike: "Не нравится",
    listen: "Слушать"
  },
  
  zh: {
    // General
    app_name: "KaanGPT",
    hello: "你好",
    loading: "加载中...",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    edit: "编辑",
    close: "关闭",
    confirm: "确认",
    search: "搜索",
    add: "添加",
    send: "发送",
    copy: "复制",
    copied: "已复制",
    download: "下载",
    upload: "上传",
    yes: "是",
    no: "否",
    or: "或",
    
    // Auth
    login: "登录",
    register: "注册",
    logout: "退出",
    email: "邮箱",
    password: "密码",
    name: "姓名",
    
    // Sidebar
    chats: "对话",
    new_chat: "新建",
    new_chat_title: "新对话",
    search_chats: "搜索对话...",
    no_chats: "暂无对话",
    no_results: "没有结果",
    archive: "归档",
    smart_assistant: "智能助手",
    
    // Welcome
    welcome: "你好！",
    welcome_user: "你好，{name}！",
    select_assistant: "选择助手开始对话",
    
    // Chat
    chat: "聊天",
    image: "图片",
    file: "文件",
    voice_on: "声音开",
    voice_off: "声音关",
    type_message: "输入消息...",
    thinking: "思考中...",
    listening: "正在听",
    stop_recording: "停止录音",
    voice_command: "语音命令",
    speak_now: "请说话...",
    voice_recognition_failed: "语音识别失败",
    voice_recognized: "语音已识别",
    voice_not_understood: "检测到音频但无法转录",
    
    // Assistants
    new_assistant: "新建",
    chatting_with: "与{name}对话",
    
    // Actions
    rename: "重命名",
    share: "分享",
    export: "导出",
    archive_chat: "归档",
    unarchive: "取消归档",
    delete_chat: "删除",
    
    // Settings
    settings: "设置",
    profile: "个人资料",
    appearance: "外观",
    notifications: "通知",
    language: "语言",
    security: "安全",
    
    // Profile
    profile_info: "个人信息",
    account_type: "账户类型",
    
    // Appearance
    theme: "主题",
    theme_dark: "深色",
    theme_light: "浅色",
    theme_system: "系统",
    font_size: "字体大小",
    font_small: "小",
    font_medium: "中",
    font_large: "大",
    auto_correct: "自动纠错",
    auto_correct_desc: "使用AI纠正拼写错误",
    
    // Language
    language_settings: "语言设置",
    app_language: "应用语言",
    language_note: "注意：语言更改立即生效。",
    
    // Security
    change_password: "修改密码",
    current_password: "当前密码",
    new_password: "新密码",
    confirm_password: "确认密码",
    
    // Feedback
    was_helpful: "这个回答有帮助吗？",
    feedback_saved: "反馈已保存",
    
    // Credits
    credits: "积分",
    subscription: "订阅",
    
    // Errors
    error_occurred: "发生错误",
    try_again: "重试",
    
    // Confirm dialogs
    delete_message_title: "删除消息",
    delete_message_confirm: "您确定要删除此消息吗？",
    delete_chat_title: "删除对话",
    delete_chat_confirm: "您确定要删除此对话吗？此操作无法撤消。",
    yes_delete: "是的，删除",
    yes_clear: "是的，清除",
    yes_cancel: "是的，取消",
    no_back: "返回",
    deleted_successfully: "删除成功",
    like: "喜欢",
    dislike: "不喜欢",
    listen: "收听"
  },
  
  ja: {
    // General
    app_name: "KaanGPT",
    hello: "こんにちは",
    loading: "読み込み中...",
    save: "保存",
    cancel: "キャンセル",
    delete: "削除",
    edit: "編集",
    close: "閉じる",
    confirm: "確認",
    search: "検索",
    add: "追加",
    send: "送信",
    copy: "コピー",
    copied: "コピーしました",
    download: "ダウンロード",
    upload: "アップロード",
    yes: "はい",
    no: "いいえ",
    or: "または",
    
    // Auth
    login: "ログイン",
    register: "登録",
    logout: "ログアウト",
    email: "メール",
    password: "パスワード",
    name: "名前",
    
    // Sidebar
    chats: "チャット",
    new_chat: "新規",
    new_chat_title: "新しいチャット",
    search_chats: "チャットを検索...",
    no_chats: "チャットなし",
    no_results: "結果なし",
    archive: "アーカイブ",
    smart_assistant: "スマートアシスタント",
    
    // Welcome
    welcome: "こんにちは！",
    welcome_user: "こんにちは、{name}さん！",
    select_assistant: "アシスタントを選んでチャットを始めましょう",
    
    // Chat
    chat: "チャット",
    image: "画像",
    file: "ファイル",
    voice_on: "音声オン",
    voice_off: "音声オフ",
    type_message: "メッセージを入力...",
    thinking: "考え中...",
    listening: "聞いています",
    stop_recording: "録音を停止",
    voice_command: "音声コマンド",
    speak_now: "話してください...",
    voice_recognition_failed: "音声認識に失敗しました",
    voice_recognized: "音声を認識しました",
    voice_not_understood: "音声を検出しましたが、文字起こしできませんでした",
    
    // Settings
    settings: "設定",
    profile: "プロフィール",
    appearance: "外観",
    notifications: "通知",
    language: "言語",
    security: "セキュリティ",
    
    // Appearance
    theme: "テーマ",
    theme_dark: "ダーク",
    theme_light: "ライト",
    theme_system: "システム",
    font_size: "フォントサイズ",
    font_small: "小",
    font_medium: "中",
    font_large: "大",
    auto_correct: "自動修正",
    auto_correct_desc: "AIでスペルミスを修正",
    
    // Language
    language_settings: "言語設定",
    app_language: "アプリの言語",
    language_note: "注：言語の変更は即座に適用されます。",
    
    // Errors
    error_occurred: "エラーが発生しました",
    try_again: "もう一度試す",
    
    // Confirm dialogs
    delete_message_title: "メッセージを削除",
    delete_message_confirm: "このメッセージを削除してもよろしいですか？",
    delete_chat_title: "チャットを削除",
    delete_chat_confirm: "このチャットを削除してもよろしいですか？この操作は取り消せません。",
    yes_delete: "はい、削除する",
    yes_clear: "はい、クリアする",
    yes_cancel: "はい、キャンセル",
    no_back: "戻る",
    deleted_successfully: "正常に削除されました",
    feedback_saved: "フィードバックを保存しました",
    like: "いいね",
    dislike: "よくないね",
    listen: "聴く"
  }
};

// Toast / runtime mesajları için ek çeviriler (App.js, modaller vs.)
const extraToasts = {
  tr: {
    chat_start_failed: "Sohbet başlatılamadı",
    message_send_failed: "Mesaj gönderilemedi",
    insufficient_credits: "Yetersiz kredi!",
    image_create_failed: "Görsel oluşturulamadı",
    image_edit_failed: "Görsel düzenlenemedi",
    image_edit_success: "Görsel düzenlendi!",
    img_analyze_action: "Analiz Et",
    img_edit_action: "Düzenle",
    img_action_hint: "Analiz için soru sorun ya da değişikliği yazıp Düzenle'ye basın.",
    face_select_btn: "Yüz Seç",
    face_clear: "Temizle",
    face_select_title: "Düzenlenecek kişiyi seç",
    face_select_desc: "Birden fazla kişi varsa, sadece düzenlemek istediğin yüze dokun. Diğer herkes olduğu gibi kalır.",
    face_select_desc_multi: "Düzenlemek istediğin kişilere dokun (birden fazla seçebilirsin). Seçilmeyen herkes olduğu gibi kalır.",
    face_detecting: "Yüzler taranıyor...",
    face_none_found: "Yüz bulunamadı. Tüm görseli düzenleyebilirsin.",
    face_edit_everyone: "Tüm görseli düzenle",
    face_count: "{n} yüz bulundu",
    face_scoped_hint: "Sadece \"{who}\" düzenlenecek. Değişikliği yazıp Düzenle'ye bas.",
    face_n_selected: "{n} kişi seçili",
    face_n_people: "{n} kişi",
    face_apply: "Seç",
    face_apply_n: "{n} kişiyi seç",
    face_per_person_hint: "İstersen her kişiye ayrı bir talimat yaz (ör. \"gözlük tak\"). Boş bırakırsan aşağıdaki genel komut uygulanır.",
    face_instruction_placeholder: "Bu kişiye ne yapılsın?",
    face_per_person_applied: "Her kişiye kendi talimatı uygulanacak. Düzenle'ye bas.",
    exchange_nav: "Binance Borsa",    exchange_title: "Binance Borsa Hesabı",
    exchange_connect_warning: "Bu özellik senin adına GERÇEK alım-satım yapabilir. API anahtarında 'Para Çekme' KAPALI olmalı. Önce Testnet ile denemen önerilir.",
    exchange_env_live: "Gerçek (Live)",
    exchange_env_testnet: "Test (Testnet)",
    exchange_keys_hint: "Binance → Profil → API Yönetimi'nden oluştur. İzinler: Okuma + Spot İşlem; Para Çekme KAPALI. Anahtarların şifreli saklanır.",
    exchange_connect_btn: "Bağlan",
    exchange_connect_failed: "Bağlantı başarısız. Anahtar/izin veya ortam hatalı olabilir.",
    exchange_keys_required: "API Key ve Secret gerekli.",
    exchange_connected: "Borsa bağlandı.",
    exchange_disconnected: "Bağlantı kaldırıldı.",
    exchange_disconnect: "Bağlantıyı kaldır",
    exchange_balances: "Bakiyeler",
    exchange_no_balance: "Bakiye bulunamadı.",
    exchange_new_order: "Yeni Emir",
    exchange_buy: "AL",
    exchange_sell: "SAT",
    exchange_quantity: "Miktar",
    exchange_price: "Fiyat",
    exchange_review_order: "Emri Gözden Geçir",
    exchange_open_orders: "Açık Emirler",
    exchange_no_orders: "Açık emir yok.",
    exchange_qty_required: "Miktar gir.",
    exchange_price_required: "Limit emri için fiyat gir.",
    exchange_order_failed: "Emir işlemi başarısız.",
    exchange_order_placed: "Emir gönderildi.",
    exchange_order_cancelled: "Emir iptal edildi.",
    exchange_confirm_title: "Emri Onayla",
    exchange_confirm_desc: "Onayladığında bu GERÇEK bir borsa emri olarak gönderilecek.",
    exchange_confirm_place: "Onayla ve Gönder",
    sol_nav: "Solana Cüzdan",
    sol_title: "Solana Cüzdanı (Phantom)",
    sol_connect_desc: "Phantom cüzdanını bağla; SOL ve token bakiyelerini gör.",
    sol_noncustodial_note: "Güvenli: Özel anahtarın tarayıcında kalır, sunucuya asla gönderilmez. Sadece herkese açık adresin okunur.",
    sol_connect_btn: "Phantom'u Bağla",
    sol_need_phantom: "Phantom cüzdanı bulunamadı. Lütfen yükleyin.",
    sol_connect_cancelled: "Bağlantı iptal edildi.",
    sol_connect_failed: "Bağlantı hatası",
    sol_iframe_note: "Cüzdan güvenlik gereği önizleme/çerçeve içinde çalışmaz. Siteyi yeni bir sekmede açıp tekrar dene.",
    sol_open_newtab: "Siteyi yeni sekmede aç",
    sol_connected: "Cüzdan bağlandı.",
    sol_balance_failed: "Bakiye alınamadı.",
    sol_tokens: "Tokenlar",
    sol_no_tokens: "Token bulunamadı.",
    sol_swap_title: "Takas (Jupiter)",
    sol_swap_from: "Gönder",
    sol_swap_to: "Al",
    sol_swap_amount: "Miktar",
    sol_swap_btn: "Takas Et",
    sol_swap_quoting: "Fiyat alınıyor...",
    sol_swap_est: "Tahmini alınacak",
    sol_swap_rate_note: "Kayma toleransı %1 · Mainnet · Phantom imzalar",
    sol_swap_insufficient: "Yetersiz bakiye",
    sol_swap_sign: "Phantom'da imzala...",
    sol_swap_submitted: "İşlem gönderildi, onay bekleniyor...",
    sol_swap_confirmed: "Takas tamamlandı!",
    sol_swap_failed: "Takas başarısız",
    sol_swap_cancelled: "İmza iptal edildi",
    sol_swap_quote_failed: "Fiyat teklifi alınamadı",
    sol_swap_view_tx: "İşlemi gör",
    sol_token_search_ph: "Token ara (örn. BONK, JUP)",
    sol_token_none: "Token bulunamadı",
    img_prompt_placeholder: "Soru sorun (analiz) veya değişiklik yazın (düzenle)...",
    memory_tab: "Dijital Ortak",
    memory_title: "Dijital Ortak Hafızası",
    memory_desc: "KaanGPT seni sohbetler arası hatırlar: tercihlerin, ilgi alanların, çalışma tarzın ve ruh halin. Bu bilgilerle her yanıtı sana özel hale getirir. Her şeyi sen kontrol edersin.",
    memory_enabled_label: "Hafızayı etkinleştir",
    memory_empty: "Henüz bir şey öğrenilmedi. Sohbet ettikçe KaanGPT seni tanımaya başlayacak.",
    memory_clear_all: "Tümünü Temizle",
    memory_mood_label: "Son ruh hali",
    memory_cleared: "Hafıza temizlendi",
    memory_update_failed: "Hafıza güncellenemedi",
    memory_cat_preference: "Tercih",
    memory_cat_interest: "İlgi alanı",
    memory_cat_work_style: "Çalışma tarzı",
    memory_cat_goal: "Hedef",
    memory_cat_personal: "Kişisel",
    attach_video: "Video oluştur",
    video_studio_title: "Video Stüdyosu",
    video_studio_desc: "Metinden veya bir görselden kısa video üretin. (Pro ve Premium üyelere özel)",
    video_prompt_placeholder: "Oluşturmak istediğiniz videoyu anlatın...",
    video_add_image: "Görsel ekle",
    video_image_hint: "İsteğe bağlı: görselden video için",
    video_duration: "Süre",    video_duration_hint: "15 sn ve üzeri videolar, art arda eklenen 5-10 sn'lik sahnelerden oluşturulur (daha uzun sürer).",
    video_transition: "Geçiş efekti",
    video_tr_fade: "Yumuşak",
    video_tr_dissolve: "Çözülme",
    video_tr_slide: "Kaydır",
    video_tr_wipe: "Silme",
    video_tr_circle: "Daire",
    video_tr_radial: "Radyal",
    video_aspect: "En/Boy",
    video_generate: "Video Oluştur",
    video_my_videos: "Videolarım",
    video_download: "İndir",
    video_share: "Paylaş",
    video_wait_hint: "1-3 dakika sürebilir",
    video_need_prompt: "Lütfen bir video açıklaması girin",
    video_started: "Video oluşturma başladı!",
    video_premium_only: "Video oluşturma Pro ve Premium üyelere özeldir. Yükseltmek ister misiniz?",
    video_failed: "Video oluşturulamadı",
    video_link_copied: "Video bağlantısı kopyalandı",
    video_status_queued: "Sırada",
    video_status_processing: "Oluşturuluyor",
    video_status_completed: "Tamamlandı",
    video_status_failed: "Başarısız",
    quota_vid_daily_hit: "Günlük video limitinize ulaştınız. Daha fazlası için planınızı yükseltin.",
    video_voiceover: "Seslendirme (opsiyonel)",
    video_narration_placeholder: "Videoda konuşulmasını istediğiniz metni yazın...",
    video_voice: "Ses",
    video_subtitles: "Altyazı ekle",
    video_voiceover_hint: "Metin OpenAI sesiyle okunup videoya eklenir. Altyazı açıksa ekrana da yazılır.",
    image_analysis_failed: "Görsel analizi başarısız",
    file_analysis_failed: "Dosya analiz edilemedi",
    unsupported_format: "Desteklenmeyen format.",
    file_too_large_10mb: "Dosya çok büyük. Maksimum 10MB.",
    file_too_large_5mb: "Dosya boyutu 10MB'dan küçük olmalı",
    only_image_formats: "Sadece JPEG, PNG veya WebP dosyaları yüklenebilir",
    please_login_first: "Lütfen önce giriş yapın",
    voice_chat_active: "Sesli sohbet modu aktif! Konuşmaya başlayın.",
    voice_chat_off: "Sesli sohbet modu kapatıldı",
    audio_play_failed: "Ses çalınamadı - tarayıcı izni gerekebilir",
    audio_create_failed: "Ses oluşturulamadı",
    voice_recognition_unsupported: "Tarayıcınız ses tanımayı desteklemiyor. Chrome veya Edge kullanın.",
    voice_recognition_start_failed: "Ses tanıma başlatılamadı",
    microphone_denied_settings: "Mikrofon izni reddedildi. Tarayıcı ayarlarından izin verin.",
    voice_not_detected: "Ses algılanamadı. Lütfen tekrar deneyin.",
    network_error_check: "Ağ hatası. İnternet bağlantınızı kontrol edin.",
    voice_recognition_error: "Ses tanıma hatası",
    voice_recognized_success: "Ses tanındı!",
    voice_start_speaking: "🎤 Konuşmaya başlayın...",
    daily_limit_exceeded: "Bugünlük ücretsiz soru sorma hakkınız bitmiştir. Devam etmek için giriş yapın veya üye olun.",
    daily_limit_short: "Bugünlük ücretsiz soru sorma hakkınız bitmiştir. Giriş yapın veya üye olun.",
    last_free_question: "Son 1 ücretsiz soru hakkınız kaldı!",
    remaining_free_questions: "Kalan ücretsiz soru hakkınız: {count}",
    new_chat_create_failed: "Yeni sohbet oluşturulamadı"
  },
  en: {
    chat_start_failed: "Could not start chat",
    message_send_failed: "Could not send message",
    insufficient_credits: "Insufficient credits!",
    image_create_failed: "Could not create image",
    image_edit_failed: "Could not edit image",
    image_edit_success: "Image edited!",
    img_analyze_action: "Analyze",
    img_edit_action: "Edit",
    img_action_hint: "Ask a question to analyze, or type a change and tap Edit.",
    face_select_btn: "Select face",
    face_clear: "Clear",
    face_select_title: "Choose who to edit",
    face_select_desc: "If there are multiple people, tap only the face you want to edit. Everyone else stays unchanged.",
    face_select_desc_multi: "Tap the people you want to edit (you can pick more than one). Everyone not selected stays unchanged.",
    face_detecting: "Scanning faces...",
    face_none_found: "No faces found. You can edit the whole image.",
    face_edit_everyone: "Edit whole image",
    face_count: "{n} faces found",
    face_scoped_hint: "Only \"{who}\" will be edited. Type the change and tap Edit.",
    face_n_selected: "{n} people selected",
    face_n_people: "{n} people",
    face_apply: "Select",
    face_apply_n: "Select {n} people",
    face_per_person_hint: "Optionally give each person a separate instruction (e.g. \"add glasses\"). Leave blank to use the general prompt below.",
    face_instruction_placeholder: "What to do to this person?",
    face_per_person_applied: "Each person gets their own instruction. Tap Edit.",
    exchange_nav: "Binance Exchange",
    exchange_title: "Binance Exchange Account",
    exchange_connect_warning: "This feature can place REAL trades on your behalf. Your API key must have 'Withdrawals' DISABLED. Testnet first is recommended.",
    exchange_env_live: "Live",
    exchange_env_testnet: "Testnet",
    exchange_keys_hint: "Create at Binance → Profile → API Management. Permissions: Read + Spot Trading; Withdrawals OFF. Your keys are stored encrypted.",
    exchange_connect_btn: "Connect",
    exchange_connect_failed: "Connection failed. Keys/permissions or environment may be wrong.",
    exchange_keys_required: "API Key and Secret are required.",
    exchange_connected: "Exchange connected.",
    exchange_disconnected: "Disconnected.",
    exchange_disconnect: "Disconnect",
    exchange_balances: "Balances",
    exchange_no_balance: "No balances found.",
    exchange_new_order: "New Order",
    exchange_buy: "BUY",
    exchange_sell: "SELL",
    exchange_quantity: "Quantity",
    exchange_price: "Price",
    exchange_review_order: "Review Order",
    exchange_open_orders: "Open Orders",
    exchange_no_orders: "No open orders.",
    exchange_qty_required: "Enter a quantity.",
    exchange_price_required: "Enter a price for a limit order.",
    exchange_order_failed: "Order action failed.",
    exchange_order_placed: "Order placed.",
    exchange_order_cancelled: "Order cancelled.",
    exchange_confirm_title: "Confirm Order",
    exchange_confirm_desc: "Once confirmed, this will be placed as a REAL exchange order.",
    exchange_confirm_place: "Confirm & Place",
    sol_nav: "Solana Wallet",
    sol_title: "Solana Wallet (Phantom)",
    sol_connect_desc: "Connect your Phantom wallet to see your SOL and token balances.",
    sol_noncustodial_note: "Secure: your private key stays in your browser and is never sent to the server. Only your public address is read.",
    sol_connect_btn: "Connect Phantom",
    sol_need_phantom: "Phantom wallet not found. Please install it.",
    sol_connect_cancelled: "Connection cancelled.",
    sol_connect_failed: "Connection error",
    sol_iframe_note: "For security, the wallet can't run inside a preview/frame. Open the site in a new tab and try again.",
    sol_open_newtab: "Open site in a new tab",
    sol_connected: "Wallet connected.",
    sol_balance_failed: "Could not fetch balances.",
    sol_tokens: "Tokens",
    sol_no_tokens: "No tokens found.",
    sol_swap_title: "Swap (Jupiter)",
    sol_swap_from: "From",
    sol_swap_to: "To",
    sol_swap_amount: "Amount",
    sol_swap_btn: "Swap",
    sol_swap_quoting: "Getting price...",
    sol_swap_est: "Estimated receive",
    sol_swap_rate_note: "1% slippage · Mainnet · Phantom signs",
    sol_swap_insufficient: "Insufficient balance",
    sol_swap_sign: "Sign in Phantom...",
    sol_swap_submitted: "Submitted, awaiting confirmation...",
    sol_swap_confirmed: "Swap complete!",
    sol_swap_failed: "Swap failed",
    sol_swap_cancelled: "Signature cancelled",
    sol_swap_quote_failed: "Could not get quote",
    sol_swap_view_tx: "View transaction",
    sol_token_search_ph: "Search token (e.g. BONK, JUP)",
    sol_token_none: "No token found",
    img_prompt_placeholder: "Ask a question (analyze) or type a change (edit)...",
    memory_tab: "Digital Partner",
    memory_title: "Digital Partner Memory",
    memory_desc: "KaanGPT remembers you across conversations: your preferences, interests, working style and mood — and personalizes every reply. You control everything.",
    memory_enabled_label: "Enable memory",
    memory_empty: "Nothing learned yet. As you chat, KaanGPT will get to know you.",
    memory_clear_all: "Clear all",
    memory_mood_label: "Recent mood",
    memory_cleared: "Memory cleared",
    memory_update_failed: "Could not update memory",
    memory_cat_preference: "Preference",
    memory_cat_interest: "Interest",
    memory_cat_work_style: "Work style",
    memory_cat_goal: "Goal",
    memory_cat_personal: "Personal",
    attach_video: "Create video",
    video_studio_title: "Video Studio",
    video_studio_desc: "Generate short videos from text or an image. (Pro and Premium members only)",
    video_prompt_placeholder: "Describe the video you want to create...",
    video_add_image: "Add image",
    video_image_hint: "Optional: for image-to-video",
    video_duration: "Duration",
    video_duration_hint: "Videos of 15s and longer are built by stitching 5-10s scenes together (takes longer).",
    video_transition: "Transition",
    video_tr_fade: "Soft fade",
    video_tr_dissolve: "Dissolve",
    video_tr_slide: "Slide",
    video_tr_wipe: "Wipe",
    video_tr_circle: "Circle",
    video_tr_radial: "Radial",
    video_aspect: "Aspect",
    video_generate: "Generate Video",
    video_my_videos: "My Videos",
    video_download: "Download",
    video_share: "Share",
    video_wait_hint: "may take 1-3 minutes",
    video_need_prompt: "Please enter a video description",
    video_started: "Video generation started!",
    video_premium_only: "Video generation is for Pro and Premium members. Would you like to upgrade?",
    video_failed: "Could not generate video",
    video_link_copied: "Video link copied",
    video_status_queued: "Queued",
    video_status_processing: "Generating",
    video_status_completed: "Completed",
    video_status_failed: "Failed",
    quota_vid_daily_hit: "You've reached your daily video limit. Upgrade your plan for more.",
    video_voiceover: "Voiceover (optional)",
    video_narration_placeholder: "Type the text you want spoken in the video...",
    video_voice: "Voice",
    video_subtitles: "Add subtitles",
    video_voiceover_hint: "The text is read with an OpenAI voice and added to the video. If subtitles are on, it's also shown on screen.",
    image_analysis_failed: "Image analysis failed",
    file_analysis_failed: "Could not analyze file",
    unsupported_format: "Unsupported format.",
    file_too_large_10mb: "File too large. Maximum 10MB.",
    file_too_large_5mb: "File size must be smaller than 10MB",
    only_image_formats: "Only JPEG, PNG or WebP files can be uploaded",
    please_login_first: "Please login first",
    voice_chat_active: "Voice chat mode active! Start speaking.",
    voice_chat_off: "Voice chat mode disabled",
    audio_play_failed: "Audio could not be played - browser permission may be required",
    audio_create_failed: "Could not create audio",
    voice_recognition_unsupported: "Your browser does not support speech recognition. Use Chrome or Edge.",
    voice_recognition_start_failed: "Could not start voice recognition",
    microphone_denied_settings: "Microphone access denied. Allow it in browser settings.",
    voice_not_detected: "No voice detected. Please try again.",
    network_error_check: "Network error. Check your internet connection.",
    voice_recognition_error: "Voice recognition error",
    voice_recognized_success: "Voice recognized!",
    voice_start_speaking: "🎤 Start speaking...",
    daily_limit_exceeded: "You have reached your daily free question limit. Please login or sign up to continue.",
    daily_limit_short: "Daily free question limit reached. Login or sign up.",
    last_free_question: "You have 1 free question left!",
    remaining_free_questions: "Remaining free questions: {count}",
    new_chat_create_failed: "Could not create new chat"
  },
  de: {
    chat_start_failed: "Chat konnte nicht gestartet werden",
    message_send_failed: "Nachricht konnte nicht gesendet werden",
    insufficient_credits: "Nicht genug Guthaben!",
    image_create_failed: "Bild konnte nicht erstellt werden",
    image_edit_failed: "Bild konnte nicht bearbeitet werden",
    image_edit_success: "Bild bearbeitet!",
    img_analyze_action: "Analysieren",
    img_edit_action: "Bearbeiten",
    img_action_hint: "Stellen Sie eine Frage zum Analysieren oder tippen Sie eine Änderung und auf Bearbeiten.",
    img_prompt_placeholder: "Frage stellen (analysieren) oder Änderung eingeben (bearbeiten)...",
    image_analysis_failed: "Bildanalyse fehlgeschlagen",
    file_analysis_failed: "Datei konnte nicht analysiert werden",
    unsupported_format: "Nicht unterstütztes Format.",
    file_too_large_10mb: "Datei zu groß. Maximal 10 MB.",
    file_too_large_5mb: "Dateigröße muss kleiner als 10 MB sein",
    only_image_formats: "Nur JPEG, PNG oder WebP Dateien können hochgeladen werden",
    please_login_first: "Bitte zuerst anmelden",
    voice_chat_active: "Sprachchat-Modus aktiv! Beginnen Sie zu sprechen.",
    voice_chat_off: "Sprachchat-Modus deaktiviert",
    audio_play_failed: "Audio konnte nicht abgespielt werden - Browser-Berechtigung erforderlich",
    audio_create_failed: "Audio konnte nicht erstellt werden",
    voice_recognition_unsupported: "Ihr Browser unterstützt keine Spracherkennung. Verwenden Sie Chrome oder Edge.",
    voice_recognition_start_failed: "Spracherkennung konnte nicht gestartet werden",
    microphone_denied_settings: "Mikrofonzugriff verweigert. In den Browser-Einstellungen erlauben.",
    voice_not_detected: "Keine Stimme erkannt. Bitte erneut versuchen.",
    network_error_check: "Netzwerkfehler. Überprüfen Sie Ihre Internetverbindung.",
    voice_recognition_error: "Spracherkennungsfehler",
    voice_recognized_success: "Stimme erkannt!",
    voice_start_speaking: "🎤 Beginnen Sie zu sprechen...",
    daily_limit_exceeded: "Sie haben Ihr tägliches Limit für kostenlose Fragen erreicht. Bitte melden Sie sich an, um fortzufahren.",
    daily_limit_short: "Tägliches Limit erreicht. Anmelden oder registrieren.",
    last_free_question: "Sie haben noch 1 kostenlose Frage übrig!",
    remaining_free_questions: "Verbleibende kostenlose Fragen: {count}",
    new_chat_create_failed: "Neuer Chat konnte nicht erstellt werden"
  },
  fr: {
    chat_start_failed: "Impossible de démarrer la conversation",
    message_send_failed: "Impossible d'envoyer le message",
    insufficient_credits: "Crédits insuffisants !",
    image_create_failed: "Impossible de créer l'image",
    image_edit_failed: "Impossible de modifier l'image",
    image_edit_success: "Image modifiée !",
    img_analyze_action: "Analyser",
    img_edit_action: "Modifier",
    img_action_hint: "Posez une question pour analyser, ou saisissez une modification et appuyez sur Modifier.",
    img_prompt_placeholder: "Posez une question (analyser) ou saisissez une modification (modifier)...",
    image_analysis_failed: "Échec de l'analyse d'image",
    file_analysis_failed: "Impossible d'analyser le fichier",
    unsupported_format: "Format non pris en charge.",
    file_too_large_10mb: "Fichier trop volumineux. Maximum 10 Mo.",
    file_too_large_5mb: "La taille du fichier doit être inférieure à 10 Mo",
    only_image_formats: "Seuls les fichiers JPEG, PNG ou WebP peuvent être téléchargés",
    please_login_first: "Veuillez d'abord vous connecter",
    voice_chat_active: "Mode chat vocal activé ! Commencez à parler.",
    voice_chat_off: "Mode chat vocal désactivé",
    audio_play_failed: "Impossible de lire l'audio - autorisation du navigateur requise",
    audio_create_failed: "Impossible de créer l'audio",
    voice_recognition_unsupported: "Votre navigateur ne prend pas en charge la reconnaissance vocale. Utilisez Chrome ou Edge.",
    voice_recognition_start_failed: "Impossible de démarrer la reconnaissance vocale",
    microphone_denied_settings: "Accès au microphone refusé. Autorisez-le dans les paramètres du navigateur.",
    voice_not_detected: "Aucune voix détectée. Veuillez réessayer.",
    network_error_check: "Erreur réseau. Vérifiez votre connexion Internet.",
    voice_recognition_error: "Erreur de reconnaissance vocale",
    voice_recognized_success: "Voix reconnue !",
    voice_start_speaking: "🎤 Commencez à parler...",
    daily_limit_exceeded: "Vous avez atteint votre limite quotidienne de questions gratuites. Connectez-vous ou inscrivez-vous pour continuer.",
    daily_limit_short: "Limite quotidienne atteinte. Connectez-vous ou inscrivez-vous.",
    last_free_question: "Il vous reste 1 question gratuite !",
    remaining_free_questions: "Questions gratuites restantes : {count}",
    new_chat_create_failed: "Impossible de créer une nouvelle conversation"
  },
  es: {
    chat_start_failed: "No se pudo iniciar el chat",
    message_send_failed: "No se pudo enviar el mensaje",
    insufficient_credits: "¡Créditos insuficientes!",
    image_create_failed: "No se pudo crear la imagen",
    image_edit_failed: "No se pudo editar la imagen",
    image_edit_success: "¡Imagen editada!",
    img_analyze_action: "Analizar",
    img_edit_action: "Editar",
    img_action_hint: "Haz una pregunta para analizar, o escribe un cambio y pulsa Editar.",
    img_prompt_placeholder: "Haz una pregunta (analizar) o escribe un cambio (editar)...",
    image_analysis_failed: "Error en el análisis de imagen",
    file_analysis_failed: "No se pudo analizar el archivo",
    unsupported_format: "Formato no compatible.",
    file_too_large_10mb: "Archivo demasiado grande. Máximo 10MB.",
    file_too_large_5mb: "El tamaño del archivo debe ser inferior a 10MB",
    only_image_formats: "Solo se pueden subir archivos JPEG, PNG o WebP",
    please_login_first: "Por favor, inicie sesión primero",
    voice_chat_active: "¡Modo chat de voz activado! Empiece a hablar.",
    voice_chat_off: "Modo chat de voz desactivado",
    audio_play_failed: "No se pudo reproducir el audio - se requiere permiso del navegador",
    audio_create_failed: "No se pudo crear el audio",
    voice_recognition_unsupported: "Su navegador no admite el reconocimiento de voz. Use Chrome o Edge.",
    voice_recognition_start_failed: "No se pudo iniciar el reconocimiento de voz",
    microphone_denied_settings: "Acceso al micrófono denegado. Permítalo en la configuración del navegador.",
    voice_not_detected: "Voz no detectada. Por favor, intente de nuevo.",
    network_error_check: "Error de red. Verifique su conexión a Internet.",
    voice_recognition_error: "Error de reconocimiento de voz",
    voice_recognized_success: "¡Voz reconocida!",
    voice_start_speaking: "🎤 Empiece a hablar...",
    daily_limit_exceeded: "Ha alcanzado su límite diario de preguntas gratuitas. Inicie sesión o regístrese para continuar.",
    daily_limit_short: "Límite diario alcanzado. Inicie sesión o regístrese.",
    last_free_question: "¡Le queda 1 pregunta gratuita!",
    remaining_free_questions: "Preguntas gratuitas restantes: {count}",
    new_chat_create_failed: "No se pudo crear nueva conversación"
  },
  ar: {
    chat_start_failed: "تعذر بدء المحادثة",
    message_send_failed: "تعذر إرسال الرسالة",
    insufficient_credits: "رصيد غير كافٍ!",
    image_create_failed: "تعذر إنشاء الصورة",
    image_edit_failed: "تعذر تعديل الصورة",
    image_edit_success: "تم تعديل الصورة!",
    img_analyze_action: "تحليل",
    img_edit_action: "تعديل",
    img_action_hint: "اطرح سؤالاً للتحليل، أو اكتب تعديلاً واضغط على تعديل.",
    img_prompt_placeholder: "اطرح سؤالاً (تحليل) أو اكتب تعديلاً (تعديل)...",
    image_analysis_failed: "فشل تحليل الصورة",
    file_analysis_failed: "تعذر تحليل الملف",
    unsupported_format: "تنسيق غير مدعوم.",
    file_too_large_10mb: "الملف كبير جدًا. الحد الأقصى 10 ميجابايت.",
    file_too_large_5mb: "يجب أن يكون حجم الملف أقل من 10 ميجابايت",
    only_image_formats: "يمكن تحميل ملفات JPEG أو PNG أو WebP فقط",
    please_login_first: "يرجى تسجيل الدخول أولاً",
    voice_chat_active: "تم تفعيل وضع الدردشة الصوتية! ابدأ الحديث.",
    voice_chat_off: "تم إيقاف وضع الدردشة الصوتية",
    audio_play_failed: "تعذر تشغيل الصوت - قد يتطلب إذن المتصفح",
    audio_create_failed: "تعذر إنشاء الصوت",
    voice_recognition_unsupported: "متصفحك لا يدعم التعرف على الصوت. استخدم Chrome أو Edge.",
    voice_recognition_start_failed: "تعذر بدء التعرف على الصوت",
    microphone_denied_settings: "تم رفض الوصول إلى الميكروفون. اسمح به في إعدادات المتصفح.",
    voice_not_detected: "لم يتم اكتشاف صوت. يرجى المحاولة مرة أخرى.",
    network_error_check: "خطأ في الشبكة. تحقق من اتصالك بالإنترنت.",
    voice_recognition_error: "خطأ في التعرف على الصوت",
    voice_recognized_success: "تم التعرف على الصوت!",
    voice_start_speaking: "🎤 ابدأ الحديث...",
    daily_limit_exceeded: "لقد وصلت إلى حد الأسئلة المجانية اليومية. سجل الدخول أو اشترك للمتابعة.",
    daily_limit_short: "تم الوصول للحد اليومي. سجل الدخول أو اشترك.",
    last_free_question: "لديك سؤال مجاني واحد متبقٍ!",
    remaining_free_questions: "الأسئلة المجانية المتبقية: {count}",
    new_chat_create_failed: "تعذر إنشاء محادثة جديدة"
  },
  ru: {
    chat_start_failed: "Не удалось начать чат",
    message_send_failed: "Не удалось отправить сообщение",
    insufficient_credits: "Недостаточно кредитов!",
    image_create_failed: "Не удалось создать изображение",
    image_edit_failed: "Не удалось отредактировать изображение",
    image_edit_success: "Изображение отредактировано!",
    img_analyze_action: "Анализ",
    img_edit_action: "Редактировать",
    img_action_hint: "Задайте вопрос для анализа или напишите изменение и нажмите Редактировать.",
    img_prompt_placeholder: "Задайте вопрос (анализ) или напишите изменение (правка)...",
    image_analysis_failed: "Ошибка анализа изображения",
    file_analysis_failed: "Не удалось проанализировать файл",
    unsupported_format: "Неподдерживаемый формат.",
    file_too_large_10mb: "Файл слишком большой. Максимум 10 МБ.",
    file_too_large_5mb: "Размер файла должен быть меньше 10 МБ",
    only_image_formats: "Можно загружать только файлы JPEG, PNG или WebP",
    please_login_first: "Пожалуйста, сначала войдите в систему",
    voice_chat_active: "Режим голосового чата активен! Начните говорить.",
    voice_chat_off: "Режим голосового чата отключен",
    audio_play_failed: "Не удалось воспроизвести аудио - требуется разрешение браузера",
    audio_create_failed: "Не удалось создать аудио",
    voice_recognition_unsupported: "Ваш браузер не поддерживает распознавание речи. Используйте Chrome или Edge.",
    voice_recognition_start_failed: "Не удалось запустить распознавание речи",
    microphone_denied_settings: "Доступ к микрофону запрещен. Разрешите в настройках браузера.",
    voice_not_detected: "Голос не обнаружен. Пожалуйста, попробуйте еще раз.",
    network_error_check: "Ошибка сети. Проверьте подключение к Интернету.",
    voice_recognition_error: "Ошибка распознавания речи",
    voice_recognized_success: "Голос распознан!",
    voice_start_speaking: "🎤 Начните говорить...",
    daily_limit_exceeded: "Вы достигли дневного лимита бесплатных вопросов. Войдите или зарегистрируйтесь для продолжения.",
    daily_limit_short: "Достигнут дневной лимит. Войдите или зарегистрируйтесь.",
    last_free_question: "У вас остался 1 бесплатный вопрос!",
    remaining_free_questions: "Осталось бесплатных вопросов: {count}",
    new_chat_create_failed: "Не удалось создать новый чат"
  },
  zh: {
    chat_start_failed: "无法开始对话",
    message_send_failed: "无法发送消息",
    insufficient_credits: "积分不足！",
    image_create_failed: "无法创建图像",
    image_edit_failed: "无法编辑图像",
    image_edit_success: "图像已编辑！",
    img_analyze_action: "分析",
    img_edit_action: "编辑",
    img_action_hint: "提问以分析，或输入修改内容并点击编辑。",
    img_prompt_placeholder: "提问（分析）或输入修改（编辑）……",
    image_analysis_failed: "图像分析失败",
    file_analysis_failed: "无法分析文件",
    unsupported_format: "不支持的格式。",
    file_too_large_10mb: "文件太大。最大10MB。",
    file_too_large_5mb: "文件大小必须小于10MB",
    only_image_formats: "只能上传JPEG、PNG或WebP文件",
    please_login_first: "请先登录",
    voice_chat_active: "语音聊天模式已激活！开始说话。",
    voice_chat_off: "语音聊天模式已关闭",
    audio_play_failed: "无法播放音频 - 可能需要浏览器权限",
    audio_create_failed: "无法创建音频",
    voice_recognition_unsupported: "您的浏览器不支持语音识别。请使用Chrome或Edge。",
    voice_recognition_start_failed: "无法启动语音识别",
    microphone_denied_settings: "麦克风访问被拒绝。请在浏览器设置中允许。",
    voice_not_detected: "未检测到声音。请重试。",
    network_error_check: "网络错误。请检查您的互联网连接。",
    voice_recognition_error: "语音识别错误",
    voice_recognized_success: "语音已识别！",
    voice_start_speaking: "🎤 开始说话...",
    daily_limit_exceeded: "您已达到每日免费问题限制。请登录或注册以继续。",
    daily_limit_short: "已达每日限制。登录或注册。",
    last_free_question: "您还剩1个免费问题！",
    remaining_free_questions: "剩余免费问题：{count}",
    new_chat_create_failed: "无法创建新对话"
  },
  ja: {
    chat_start_failed: "チャットを開始できませんでした",
    message_send_failed: "メッセージを送信できませんでした",
    insufficient_credits: "クレジットが不足しています！",
    image_create_failed: "画像を作成できませんでした",
    image_edit_failed: "画像を編集できませんでした",
    image_edit_success: "画像を編集しました！",
    img_analyze_action: "分析",
    img_edit_action: "編集",
    img_action_hint: "分析するには質問し、変更するには内容を入力して編集を押してください。",
    img_prompt_placeholder: "質問する（分析）または変更を入力（編集）...",
    image_analysis_failed: "画像分析に失敗しました",
    file_analysis_failed: "ファイルを分析できませんでした",
    unsupported_format: "サポートされていない形式です。",
    file_too_large_10mb: "ファイルが大きすぎます。最大10MB。",
    file_too_large_5mb: "ファイルサイズは10MB未満である必要があります",
    only_image_formats: "JPEG、PNG、またはWebPファイルのみアップロードできます",
    please_login_first: "最初にログインしてください",
    voice_chat_active: "音声チャットモードが有効です！話し始めてください。",
    voice_chat_off: "音声チャットモードがオフです",
    audio_play_failed: "音声を再生できませんでした - ブラウザの許可が必要な場合があります",
    audio_create_failed: "音声を作成できませんでした",
    voice_recognition_unsupported: "お使いのブラウザは音声認識をサポートしていません。ChromeまたはEdgeを使用してください。",
    voice_recognition_start_failed: "音声認識を開始できませんでした",
    microphone_denied_settings: "マイクへのアクセスが拒否されました。ブラウザ設定で許可してください。",
    voice_not_detected: "音声が検出されませんでした。もう一度お試しください。",
    network_error_check: "ネットワークエラー。インターネット接続を確認してください。",
    voice_recognition_error: "音声認識エラー",
    voice_recognized_success: "音声を認識しました！",
    voice_start_speaking: "🎤 話し始めてください...",
    daily_limit_exceeded: "1日の無料質問の上限に達しました。続けるにはログインまたは登録してください。",
    daily_limit_short: "1日の制限に達しました。ログインまたは登録してください。",
    last_free_question: "無料質問が残り1つです！",
    remaining_free_questions: "残りの無料質問：{count}",
    new_chat_create_failed: "新しいチャットを作成できませんでした"
  }
};

// Merge extra toasts into main translations
Object.keys(extraToasts).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], extraToasts[lang]);
  }
});

// Model mode translations for AI selector
const modelModeTranslations = {
  tr: {
    ai_model_mode: "AI Modeli",
    ai_model_mode_desc: "Hangi yapay zeka modeli kullanılsın? Otomatik mod, mesaj karmaşıklığına göre en uygun modeli seçer.",
    model_fast: "Hızlı",
    model_fast_desc: "En hızlı + ucuz",
    model_auto: "Otomatik",
    model_auto_desc: "Akıllı seçim",
    model_pro: "Pro",
    model_pro_desc: "En güçlü model"
  },
  en: {
    ai_model_mode: "AI Model",
    ai_model_mode_desc: "Which AI model to use? Auto mode selects the best model based on message complexity.",
    model_fast: "Fast",
    model_fast_desc: "Fastest + cheap",
    model_auto: "Auto",
    model_auto_desc: "Smart routing",
    model_pro: "Pro",
    model_pro_desc: "Most powerful"
  },
  de: {
    ai_model_mode: "KI-Modell",
    ai_model_mode_desc: "Welches KI-Modell verwenden? Auto wählt das beste Modell je nach Komplexität.",
    model_fast: "Schnell",
    model_fast_desc: "Am schnellsten + günstig",
    model_auto: "Auto",
    model_auto_desc: "Intelligente Auswahl",
    model_pro: "Pro",
    model_pro_desc: "Leistungsstärkstes"
  },
  fr: {
    ai_model_mode: "Modèle IA",
    ai_model_mode_desc: "Quel modèle IA utiliser ? Auto choisit le meilleur selon la complexité.",
    model_fast: "Rapide",
    model_fast_desc: "Le plus rapide + bon marché",
    model_auto: "Auto",
    model_auto_desc: "Sélection intelligente",
    model_pro: "Pro",
    model_pro_desc: "Le plus puissant"
  },
  es: {
    ai_model_mode: "Modelo IA",
    ai_model_mode_desc: "¿Qué modelo de IA usar? Auto elige el mejor según la complejidad.",
    model_fast: "Rápido",
    model_fast_desc: "Más rápido + barato",
    model_auto: "Auto",
    model_auto_desc: "Selección inteligente",
    model_pro: "Pro",
    model_pro_desc: "Más potente"
  },
  ar: {
    ai_model_mode: "نموذج الذكاء الاصطناعي",
    ai_model_mode_desc: "أي نموذج ذكاء اصطناعي تستخدم؟ الوضع التلقائي يختار الأفضل حسب التعقيد.",
    model_fast: "سريع",
    model_fast_desc: "الأسرع + رخيص",
    model_auto: "تلقائي",
    model_auto_desc: "اختيار ذكي",
    model_pro: "احترافي",
    model_pro_desc: "الأقوى"
  },
  ru: {
    ai_model_mode: "Модель ИИ",
    ai_model_mode_desc: "Какую модель ИИ использовать? Авто выбирает лучшую по сложности.",
    model_fast: "Быстрый",
    model_fast_desc: "Самый быстрый + дешёвый",
    model_auto: "Авто",
    model_auto_desc: "Умный выбор",
    model_pro: "Pro",
    model_pro_desc: "Самый мощный"
  },
  zh: {
    ai_model_mode: "AI 模型",
    ai_model_mode_desc: "使用哪个AI模型？自动模式根据复杂度选择最佳模型。",
    model_fast: "快速",
    model_fast_desc: "最快 + 便宜",
    model_auto: "自动",
    model_auto_desc: "智能选择",
    model_pro: "专业",
    model_pro_desc: "最强大"
  },
  ja: {
    ai_model_mode: "AIモデル",
    ai_model_mode_desc: "どのAIモデルを使う？自動モードは複雑さに応じて最適なものを選択します。",
    model_fast: "高速",
    model_fast_desc: "最速 + 低コスト",
    model_auto: "自動",
    model_auto_desc: "スマート選択",
    model_pro: "プロ",
    model_pro_desc: "最強"
  }
};

Object.keys(modelModeTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], modelModeTranslations[lang]);
  }
});

// Pro mode lock translations
const proLockTranslations = {
  tr: { pro_mode_locked: "Pro modu Premium üyelere özeldir. Üye olun veya planınızı yükseltin.", premium: "Premium" },
  en: { pro_mode_locked: "Pro mode is for Premium members only. Subscribe or upgrade your plan.", premium: "Premium" },
  de: { pro_mode_locked: "Pro-Modus ist nur für Premium-Mitglieder. Abonnieren oder upgraden Sie.", premium: "Premium" },
  fr: { pro_mode_locked: "Le mode Pro est réservé aux membres Premium. Abonnez-vous ou améliorez votre forfait.", premium: "Premium" },
  es: { pro_mode_locked: "El modo Pro es solo para miembros Premium. Suscríbase o actualice su plan.", premium: "Premium" },
  ar: { pro_mode_locked: "وضع Pro متاح فقط للأعضاء المميزين. اشترك أو قم بترقية خطتك.", premium: "مميز" },
  ru: { pro_mode_locked: "Режим Pro доступен только Premium-пользователям. Подпишитесь или улучшите план.", premium: "Premium" },
  zh: { pro_mode_locked: "Pro 模式仅供 Premium 会员使用。请订阅或升级您的计划。", premium: "高级版" },
  ja: { pro_mode_locked: "ProモードはPremiumメンバー専用です。登録またはプランをアップグレードしてください。", premium: "プレミアム" }
};

Object.keys(proLockTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], proLockTranslations[lang]);
  }
});

// Upgrade modal (mini Pro upsell) translations
const upgradeModalTranslations = {
  tr: {
    upgrade_pro_title: "Pro AI'yı Keşfet",
    upgrade_pro_subtitle: "En akıllı modelle daha derin, doğru ve hızlı yanıtlar al.",
    upgrade_benefit_1: "Karmaşık sorularda en güçlü model (Claude Sonnet)",
    upgrade_benefit_2: "Daha uzun ve detaylı yanıtlar",
    upgrade_benefit_3: "Öncelikli işlem ve hız",
    upgrade_now: "Hemen Yükselt",
    view_all_plans: "Tüm planları gör",
    maybe_later: "Belki sonra",
    recommended: "Önerilen"
  },
  en: {
    upgrade_pro_title: "Unlock Pro AI",
    upgrade_pro_subtitle: "Get deeper, sharper, faster answers from the smartest model.",
    upgrade_benefit_1: "Most powerful model for complex questions (Claude Sonnet)",
    upgrade_benefit_2: "Longer, more detailed responses",
    upgrade_benefit_3: "Priority processing & speed",
    upgrade_now: "Upgrade Now",
    view_all_plans: "View all plans",
    maybe_later: "Maybe later",
    recommended: "Recommended"
  },
  de: {
    upgrade_pro_title: "Pro KI freischalten",
    upgrade_pro_subtitle: "Tiefere, schärfere und schnellere Antworten vom intelligentesten Modell.",
    upgrade_benefit_1: "Stärkstes Modell für komplexe Fragen (Claude Sonnet)",
    upgrade_benefit_2: "Längere, detailliertere Antworten",
    upgrade_benefit_3: "Bevorzugte Verarbeitung & Geschwindigkeit",
    upgrade_now: "Jetzt upgraden",
    view_all_plans: "Alle Pläne ansehen",
    maybe_later: "Vielleicht später",
    recommended: "Empfohlen"
  },
  fr: {
    upgrade_pro_title: "Débloquez l'IA Pro",
    upgrade_pro_subtitle: "Des réponses plus profondes, précises et rapides du modèle le plus intelligent.",
    upgrade_benefit_1: "Modèle le plus puissant pour les questions complexes (Claude Sonnet)",
    upgrade_benefit_2: "Réponses plus longues et détaillées",
    upgrade_benefit_3: "Traitement et vitesse prioritaires",
    upgrade_now: "Améliorer maintenant",
    view_all_plans: "Voir tous les plans",
    maybe_later: "Peut-être plus tard",
    recommended: "Recommandé"
  },
  es: {
    upgrade_pro_title: "Desbloquea la IA Pro",
    upgrade_pro_subtitle: "Respuestas más profundas, precisas y rápidas del modelo más inteligente.",
    upgrade_benefit_1: "Modelo más potente para preguntas complejas (Claude Sonnet)",
    upgrade_benefit_2: "Respuestas más largas y detalladas",
    upgrade_benefit_3: "Procesamiento y velocidad prioritarios",
    upgrade_now: "Actualizar ahora",
    view_all_plans: "Ver todos los planes",
    maybe_later: "Quizás más tarde",
    recommended: "Recomendado"
  },
  ar: {
    upgrade_pro_title: "افتح وضع Pro",
    upgrade_pro_subtitle: "احصل على إجابات أعمق وأدق وأسرع من أذكى نموذج.",
    upgrade_benefit_1: "أقوى نموذج للأسئلة المعقدة (Claude Sonnet)",
    upgrade_benefit_2: "إجابات أطول وأكثر تفصيلاً",
    upgrade_benefit_3: "أولوية في المعالجة والسرعة",
    upgrade_now: "ترقية الآن",
    view_all_plans: "عرض جميع الخطط",
    maybe_later: "ربما لاحقاً",
    recommended: "موصى به"
  },
  ru: {
    upgrade_pro_title: "Откройте Pro AI",
    upgrade_pro_subtitle: "Получайте более глубокие, точные и быстрые ответы от умнейшей модели.",
    upgrade_benefit_1: "Самая мощная модель для сложных вопросов (Claude Sonnet)",
    upgrade_benefit_2: "Длинные и подробные ответы",
    upgrade_benefit_3: "Приоритетная обработка и скорость",
    upgrade_now: "Улучшить сейчас",
    view_all_plans: "Все тарифы",
    maybe_later: "Может позже",
    recommended: "Рекомендуем"
  },
  zh: {
    upgrade_pro_title: "解锁 Pro AI",
    upgrade_pro_subtitle: "从最智能的模型获取更深入、精准、快速的回答。",
    upgrade_benefit_1: "最强模型应对复杂问题 (Claude Sonnet)",
    upgrade_benefit_2: "更长更详细的回复",
    upgrade_benefit_3: "优先处理和速度",
    upgrade_now: "立即升级",
    view_all_plans: "查看所有套餐",
    maybe_later: "稍后再说",
    recommended: "推荐"
  },
  ja: {
    upgrade_pro_title: "Pro AIを解放",
    upgrade_pro_subtitle: "最も賢いモデルから、より深く、鋭く、速い回答を。",
    upgrade_benefit_1: "複雑な質問に最強モデル (Claude Sonnet)",
    upgrade_benefit_2: "より長く詳細な応答",
    upgrade_benefit_3: "優先処理とスピード",
    upgrade_now: "今すぐアップグレード",
    view_all_plans: "すべてのプランを見る",
    maybe_later: "後でね",
    recommended: "おすすめ"
  }
};

Object.keys(upgradeModalTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], upgradeModalTranslations[lang]);
  }
});

// Voice transcribing indicator translations
const voiceProcessingTranslations = {
  tr: { processing: "İşleniyor...", speaking: "Konuşuyor" },
  en: { processing: "Processing...", speaking: "Speaking" },
  de: { processing: "Verarbeitung...", speaking: "Spricht" },
  fr: { processing: "Traitement...", speaking: "Parle" },
  es: { processing: "Procesando...", speaking: "Hablando" },
  ar: { processing: "جارٍ المعالجة...", speaking: "يتحدث" },
  ru: { processing: "Обработка...", speaking: "Говорит" },
  zh: { processing: "处理中...", speaking: "正在说话" },
  ja: { processing: "処理中...", speaking: "話しています" }
};
Object.keys(voiceProcessingTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], voiceProcessingTranslations[lang]);
  }
});

// Deep Research translations
const deepResearchTranslations = {
  tr: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — Binlerce Ajanla Derin Analiz",
    dr_intro_desc: "Büyük bir görev verin. KaanLab uzman ajan sürüsü 10 fazda çalışıp size profesyonel bir rapor hazırlar.",
    dr_agents_in_pool: "Uzman ajan",
    dr_phases: "Faz",
    dr_delivery: "Teslimat",
    dr_delivery_value: "~5-15 dk",
    dr_pricing_note: "Tek görev ücreti: {price} (~ 65 TL değerinde LLM işlemi + KaanLab çok-fazlı orkestrasyon). Ödeme sonrası görev başlar.",
    dr_get_started: "Başlayalım",
    dr_pick_domain: "Alan Seçin",
    dr_pick_domain_desc: "Görevinize en uygun uzmanlık alanını seçin",
    dr_domain_market: "Pazar Analizi",
    dr_domain_market_desc: "SWOT, rakip, tüketici, trend, fiyatlandırma",
    dr_domain_academic: "Akademik Araştırma",
    dr_domain_academic_desc: "Literatür taraması, metodoloji, kaynak",
    dr_domain_business: "İş Planı & Yatırım",
    dr_domain_business_desc: "Finansal model, değerleme, pitch deck",
    dr_domain_creative: "Yaratıcı Proje",
    dr_domain_creative_desc: "Marka, hikaye, karakter, senaryo",
    dr_domain_technical: "Teknik Deep Dive",
    dr_domain_technical_desc: "Mimari, teknoloji karşılaştırma, güvenlik",
    dr_task_prompt: "Görevinizi olabildiğince detaylı yazın",
    dr_task_placeholder: "Örnek: Türkiye'de elektrikli araç pazarını 2026 için analiz et: ana oyuncular, tüketici davranışları, regülasyonlar, 3 yıllık projeksiyon, fırsatlar ve riskler...",
    dr_task_too_short: "En az 20 karakter yazın",
    dr_task_ok: "Hazır",
    dr_pay_and_start: "Öde ve Başlat ({price})",
    dr_start_free_admin: "Ücretsiz Başlat (Admin)",
    dr_payment_failed: "Ödeme başlatılamadı",
    dr_error: "Bir hata oluştu",
    dr_job_started: "KaanLab görevi başlatıldı!",
    dr_job_title: "KaanLab Görevi",
    dr_progress: "İlerleme",
    dr_agents_short: "ajan",
    dr_report_ready: "Rapor hazır!",
    dr_download_failed: "İndirme başarısız",
    dr_job_failed: "Görev başarısız oldu",
    dr_queued: "Sırada",
    dr_running: "Çalışıyor",
    dr_completed: "Tamamlandı",
    dr_failed: "Başarısız",
    dr_cancelled: "İptal edildi",
    dr_job_resume: "Devam Et",
    dr_job_resumed: "Görev kaldığı yerden sürdürülüyor…",
    dr_job_resume_hint: "Bu görev iptal edildi. Tamamlanan aşamalar korunur; kaldığı yerden devam edebilirsin.",
    dr_phase_discovery: "1. Keşif",
    dr_phase_landscape: "2. Genel Görünüm",
    dr_phase_deepdive: "3. Derinleşme",
    dr_phase_data: "4. Veri & Kanıt",
    dr_phase_stakeholder: "5. Paydaş Perspektifleri",
    dr_phase_verify: "6. Doğrulama",
    dr_phase_risk: "7. Risk & Fırsat",
    dr_phase_strategy: "8. Strateji & Öneriler",
    dr_phase_synthesis: "9. Sentez",
    dr_phase_editorial: "10. Editörlük",
    dr_planner_decision: "AI Planlayıcı Kararı",
    dr_complexity_simple: "Basit",
    dr_complexity_medium: "Orta",
    dr_complexity_complex: "Karmaşık",
    dr_complexity_enterprise: "Kurumsal-Devasa",
    dr_gdocs_note: "Word dosyasını Google Docs'a yükleyin (otomatik dönüşür)",
    dr_leaderboard_title: "Ajan Liderlik Tablosu",
    dr_leaderboard_desc: "KaanLab görevlerinde en çok kullanılan ajanlar",
    dr_leaderboard_calls: "çağrı",
    dr_leaderboard_unique: "farklı ajan kullanıldı",
    dr_jobs_history_title: "Görevlerim",
    dr_jobs_history_desc: "Geçmiş KaanLab görevleriniz",
    dr_jobs_total: "görev",
    dr_no_jobs_yet: "Henüz görev yok",
    dr_no_jobs_hint: "İlk KaanLab görevinizi başlatmak için 🌊 butonuna tıklayın",
    custom_agents_title: "Özel Ajanlarım",
    custom_agents_desc: "KaanLab görevlerinize özel ajanlarınızı ekleyin (max 20)",
    custom_agents_slot: "slot kullanıldı",
    custom_agents_empty: "Henüz özel ajan yok",
    custom_agents_empty_hint: "Yeni Ajan butonuna basıp kendi uzmanınızı tanımlayın",
    custom_agent_new: "Yeni Ajan",
    custom_agent_name: "İsim",
    custom_agent_role: "Rol",
    custom_agent_domain: "Alan",
    custom_agent_phase: "Faz",
    custom_agent_prompt: "Sistem Talimatı (bu ajan nasıl davransın?)",
    custom_agent_save: "Kaydet",
    custom_agent_created: "Ajan oluşturuldu",
    custom_agent_error: "Ajan işlemi başarısız",
    custom_agent_validation: "İsim en az 2, talimat en az 20 karakter olmalı",
    custom_agent_delete_confirm: "Bu özel ajanı silmek istiyor musunuz?",
    dr_job_delete_confirm: "Bu görevi silmek istiyor musunuz? Rapor kalıcı olarak kaybolacak.",
    dr_job_deleted: "Görev silindi",
    dr_job_rerun: "Tekrar Çalıştır",
    dr_job_rerun_started: "Görev tekrar başlatıldı",
    dr_challenger_mode: "⚡ Challenger Modu — meydan oku",
    dr_challenger_started: "Challenger raporu başladı — karşı-argümanlar üretiliyor",
    dr_job_cancel: "İptal Et",
    dr_job_cancel_confirm: "Bu görevi iptal etmek istiyor musunuz? İşlem durdurulacak ve rapor tamamlanmayacak.",
    dr_job_cancelled: "Görev iptal edildi",
    dr_share: "Paylaş",
    dr_shared_ok: "Rapor paylaşıldı",
    dr_shared_copied: "Rapor panoya kopyalandı 📋",
    dr_share_failed: "Paylaşım başarısız oldu",
    quota_msg_daily_warm: "Bugünlük harika sohbet ettik! 💜",
    quota_msg_daily_warm_desc: "Günlük ücretsiz mesaj hakkın doldu. Sınırsız sohbet için bir plana göz atmaya ne dersin?",
    quota_upgrade_cta: "Planlara Göz At",
    delete: "Sil",
    cancel: "İptal",
    coming_soon: "yakında",
    back: "Geri",
    loading: "Yükleniyor...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 kredi/ay",
    plan_enterprise_f2: "Sınırsız AI erişimi",
    plan_enterprise_f3: "API erişimi",
    plan_enterprise_f4: "5 KaanLab/ay dahil",
    plan_enterprise_f5: "Öncelikli destek 7/24",
    plan_enterprise_f6: "Ekip yönetimi",
    plan_enterprise_f7: "Özel branding",
  },
  en: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — In-Depth Analysis with Thousands of Agents",
    dr_intro_desc: "Give a big task. KaanLab's swarm of specialist agents works in 10 phases and delivers a professional report.",
    dr_agents_in_pool: "Expert agents",
    dr_phases: "Phases",
    dr_delivery: "Delivery",
    dr_delivery_value: "~5-15 min",
    dr_pricing_note: "One-off task price: {price} (~65 TL of LLM operations + KaanLab multi-phase orchestration). Task starts after payment.",
    dr_get_started: "Get Started",
    dr_pick_domain: "Pick a Domain",
    dr_pick_domain_desc: "Choose the specialty that best fits your task",
    dr_domain_market: "Market Analysis",
    dr_domain_market_desc: "SWOT, competitors, consumers, trends, pricing",
    dr_domain_academic: "Academic Research",
    dr_domain_academic_desc: "Literature review, methodology, citations",
    dr_domain_business: "Business Plan & Investment",
    dr_domain_business_desc: "Financial model, valuation, pitch deck",
    dr_domain_creative: "Creative Project",
    dr_domain_creative_desc: "Brand, story, character, screenplay",
    dr_domain_technical: "Technical Deep Dive",
    dr_domain_technical_desc: "Architecture, tech comparison, security",
    dr_task_prompt: "Describe your task in as much detail as possible",
    dr_task_placeholder: "Example: Analyse Turkey's EV market for 2026: key players, consumer behaviour, regulations, 3-year projection, opportunities and risks...",
    dr_task_too_short: "Write at least 20 characters",
    dr_task_ok: "Ready",
    dr_pay_and_start: "Pay & Start ({price})",
    dr_start_free_admin: "Start Free (Admin)",
    dr_payment_failed: "Payment could not start",
    dr_error: "An error occurred",
    dr_job_started: "KaanLab job started!",
    dr_job_title: "KaanLab Job",
    dr_progress: "Progress",
    dr_agents_short: "agents",
    dr_report_ready: "Report ready!",
    dr_download_failed: "Download failed",
    dr_job_failed: "Job failed",
    dr_queued: "Queued",
    dr_running: "Running",
    dr_completed: "Completed",
    dr_failed: "Failed",
    dr_cancelled: "Cancelled",
    dr_job_resume: "Resume",
    dr_job_resumed: "Resuming from where it stopped…",
    dr_job_resume_hint: "This job was cancelled. Completed phases are kept; you can continue from where it stopped.",
    dr_phase_discovery: "1. Discovery",
    dr_phase_landscape: "2. Landscape",
    dr_phase_deepdive: "3. Deep-dive",
    dr_phase_data: "4. Data & Evidence",
    dr_phase_stakeholder: "5. Stakeholder Views",
    dr_phase_verify: "6. Verification",
    dr_phase_risk: "7. Risk & Opportunity",
    dr_phase_strategy: "8. Strategy & Recommendations",
    dr_phase_synthesis: "9. Synthesis",
    dr_phase_editorial: "10. Editorial",
    dr_planner_decision: "AI Planner Decision",
    dr_complexity_simple: "Simple",
    dr_complexity_medium: "Medium",
    dr_complexity_complex: "Complex",
    dr_complexity_enterprise: "Enterprise-Grade",
    dr_gdocs_note: "Upload the Word file to Google Docs (auto-converts)",
    dr_leaderboard_title: "Agent Leaderboard",
    dr_leaderboard_desc: "Most-used agents across KaanLab jobs",
    dr_leaderboard_calls: "calls",
    dr_leaderboard_unique: "unique agents used",
    dr_jobs_history_title: "My Jobs",
    dr_jobs_history_desc: "Your past KaanLab jobs",
    dr_jobs_total: "jobs",
    dr_no_jobs_yet: "No jobs yet",
    dr_no_jobs_hint: "Click the 🌊 button to start your first KaanLab job",
    custom_agents_title: "My Custom Agents",
    custom_agents_desc: "Add your own specialised agents to KaanLab jobs (max 20)",
    custom_agents_slot: "slots used",
    custom_agents_empty: "No custom agents yet",
    custom_agents_empty_hint: "Click New Agent to define your specialist",
    custom_agent_new: "New Agent",
    custom_agent_name: "Name",
    custom_agent_role: "Role",
    custom_agent_domain: "Domain",
    custom_agent_phase: "Phase",
    custom_agent_prompt: "System Prompt (how should this agent behave?)",
    custom_agent_save: "Save",
    custom_agent_created: "Agent created",
    custom_agent_error: "Agent operation failed",
    custom_agent_validation: "Name at least 2 chars, prompt at least 20 chars",
    custom_agent_delete_confirm: "Delete this custom agent?",
    dr_job_delete_confirm: "Delete this job? The report will be lost forever.",
    dr_job_deleted: "Job deleted",
    dr_job_rerun: "Re-run",
    dr_job_rerun_started: "Job re-started",
    dr_challenger_mode: "⚡ Challenger Mode — challenge findings",
    dr_challenger_started: "Challenger report started — generating counter-arguments",
    dr_job_cancel: "Cancel",
    dr_job_cancel_confirm: "Cancel this job? It will stop and the report won't be completed.",
    dr_job_cancelled: "Job cancelled",
    dr_share: "Share",
    dr_shared_ok: "Report shared",
    dr_shared_copied: "Report copied to clipboard 📋",
    dr_share_failed: "Sharing failed",
    quota_msg_daily_warm: "Great chatting today! 💜",
    quota_msg_daily_warm_desc: "You've used your free daily messages. How about a plan for unlimited chats?",
    quota_upgrade_cta: "See Plans",
    delete: "Delete",
    cancel: "Cancel",
    coming_soon: "coming soon",
    back: "Back",
    loading: "Loading...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 credits/mo",
    plan_enterprise_f2: "Unlimited AI access",
    plan_enterprise_f3: "API access",
    plan_enterprise_f4: "5 KaanLab jobs/mo included",
    plan_enterprise_f5: "Priority 24/7 support",
    plan_enterprise_f6: "Team management",
    plan_enterprise_f7: "Custom branding",
  },
  de: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — Tiefgehende Analyse mit Tausenden Agenten",
    dr_intro_desc: "Stellen Sie eine große Aufgabe. Der Spezialisten-Schwarm von KaanLab arbeitet in 10 Phasen und liefert einen professionellen Bericht.",
    dr_agents_in_pool: "Experten-Agenten",
    dr_phases: "Phasen",
    dr_delivery: "Lieferung",
    dr_pricing_note: "Einmaliger Aufgabenpreis: {price} (~65 TL an LLM-Vorgängen + KaanLab-Mehrphasen-Orchestrierung). Die Aufgabe startet nach der Zahlung.",
    dr_get_started: "Loslegen",
    dr_pick_domain: "Fachgebiet wählen",
    dr_pick_domain_desc: "Wählen Sie die Spezialisierung, die am besten zu Ihrer Aufgabe passt",
    dr_domain_market: "Marktanalyse",
    dr_domain_market_desc: "SWOT, Wettbewerber, Verbraucher, Trends, Preise",
    dr_domain_academic: "Akademische Forschung",
    dr_domain_academic_desc: "Literaturübersicht, Methodik, Zitate",
    dr_domain_business: "Businessplan & Investment",
    dr_domain_business_desc: "Finanzmodell, Bewertung, Pitch Deck",
    dr_domain_creative: "Kreatives Projekt",
    dr_domain_creative_desc: "Marke, Story, Charakter, Drehbuch",
    dr_domain_technical: "Technische Tiefenanalyse",
    dr_domain_technical_desc: "Architektur, Technologievergleich, Sicherheit",
    dr_task_prompt: "Beschreiben Sie Ihre Aufgabe so detailliert wie möglich",
    dr_task_placeholder: "Beispiel: Analysieren Sie den türkischen E-Auto-Markt für 2026: Hauptakteure, Verbraucherverhalten, Vorschriften, 3-Jahres-Prognose, Chancen und Risiken...",
    dr_task_too_short: "Mindestens 20 Zeichen schreiben",
    dr_task_ok: "Bereit",
    dr_pay_and_start: "Bezahlen & Starten ({price})",
    dr_start_free_admin: "Kostenlos starten (Admin)",
    dr_payment_failed: "Zahlung konnte nicht gestartet werden",
    dr_error: "Ein Fehler ist aufgetreten",
    dr_job_started: "KaanLab-Auftrag gestartet!",
    dr_job_title: "KaanLab-Auftrag",
    dr_progress: "Fortschritt",
    dr_agents_short: "Agenten",
    dr_report_ready: "Bericht fertig!",
    dr_download_failed: "Download fehlgeschlagen",
    dr_job_failed: "Auftrag fehlgeschlagen",
    dr_queued: "In Warteschlange",
    dr_running: "Läuft",
    dr_completed: "Abgeschlossen",
    dr_failed: "Fehlgeschlagen",
    dr_cancelled: "Abgebrochen",
    dr_job_resume: "Fortsetzen",
    dr_job_resumed: "Wird dort fortgesetzt, wo es gestoppt wurde…",
    dr_job_resume_hint: "Dieser Auftrag wurde abgebrochen. Abgeschlossene Phasen bleiben erhalten; Sie können dort fortfahren, wo es gestoppt wurde.",
    dr_phase_discovery: "1. Erkundung",
    dr_phase_landscape: "2. Überblick",
    dr_phase_deepdive: "3. Tiefenanalyse",
    dr_phase_data: "4. Daten & Belege",
    dr_phase_stakeholder: "5. Stakeholder-Sichten",
    dr_phase_verify: "6. Überprüfung",
    dr_phase_risk: "7. Risiko & Chance",
    dr_phase_strategy: "8. Strategie & Empfehlungen",
    dr_phase_synthesis: "9. Synthese",
    dr_phase_editorial: "10. Redaktion",
    dr_planner_decision: "KI-Planer-Entscheidung",
    dr_complexity_simple: "Einfach",
    dr_complexity_medium: "Mittel",
    dr_complexity_complex: "Komplex",
    dr_complexity_enterprise: "Unternehmensniveau",
    dr_gdocs_note: "Laden Sie die Word-Datei in Google Docs hoch (automatische Konvertierung)",
    dr_leaderboard_title: "Agenten-Rangliste",
    dr_leaderboard_desc: "Meistgenutzte Agenten in KaanLab-Aufträgen",
    dr_leaderboard_calls: "Aufrufe",
    dr_leaderboard_unique: "eindeutige Agenten verwendet",
    dr_jobs_history_title: "Meine Aufträge",
    dr_jobs_history_desc: "Ihre vergangenen KaanLab-Aufträge",
    dr_jobs_total: "Aufträge",
    dr_no_jobs_yet: "Noch keine Aufträge",
    dr_no_jobs_hint: "Klicken Sie auf die 🌊-Schaltfläche, um Ihren ersten KaanLab-Auftrag zu starten",
    custom_agents_title: "Meine benutzerdefinierten Agenten",
    custom_agents_desc: "Fügen Sie KaanLab-Aufträgen eigene Spezialagenten hinzu (max. 20)",
    custom_agents_slot: "Plätze belegt",
    custom_agents_empty: "Noch keine benutzerdefinierten Agenten",
    custom_agents_empty_hint: "Klicken Sie auf Neuer Agent, um Ihren Spezialisten zu definieren",
    custom_agent_new: "Neuer Agent",
    custom_agent_name: "Name",
    custom_agent_role: "Rolle",
    custom_agent_domain: "Fachgebiet",
    custom_agent_phase: "Phase",
    custom_agent_prompt: "System-Prompt (wie soll sich dieser Agent verhalten?)",
    custom_agent_save: "Speichern",
    custom_agent_created: "Agent erstellt",
    custom_agent_error: "Agenten-Vorgang fehlgeschlagen",
    custom_agent_validation: "Name mind. 2 Zeichen, Prompt mind. 20 Zeichen",
    custom_agent_delete_confirm: "Diesen benutzerdefinierten Agenten löschen?",
    dr_job_delete_confirm: "Diesen Auftrag löschen? Der Bericht geht für immer verloren.",
    dr_job_deleted: "Auftrag gelöscht",
    dr_job_rerun: "Erneut ausführen",
    dr_job_rerun_started: "Auftrag neu gestartet",
    dr_challenger_mode: "⚡ Challenger-Modus — Ergebnisse hinterfragen",
    dr_challenger_started: "Challenger-Bericht gestartet — Gegenargumente werden erzeugt",
    dr_job_cancel: "Abbrechen",
    dr_job_cancel_confirm: "Diesen Auftrag abbrechen? Er wird gestoppt und der Bericht nicht fertiggestellt.",
    dr_job_cancelled: "Auftrag abgebrochen",
    dr_share: "Teilen",
    dr_shared_ok: "Bericht geteilt",
    dr_shared_copied: "Bericht in die Zwischenablage kopiert 📋",
    dr_share_failed: "Teilen fehlgeschlagen",
    quota_msg_daily_warm: "Schönes Gespräch heute! 💜",
    quota_msg_daily_warm_desc: "Sie haben Ihre kostenlosen Tagesnachrichten aufgebraucht. Wie wäre es mit einem Tarif für unbegrenzte Chats?",
    quota_upgrade_cta: "Tarife ansehen",
    delete: "Löschen",
    cancel: "Abbrechen",
    coming_soon: "demnächst",
    back: "Zurück",
    loading: "Wird geladen...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 Credits/Mon.",
    plan_enterprise_f2: "Unbegrenzter KI-Zugang",
    plan_enterprise_f3: "API-Zugang",
    plan_enterprise_f4: "5 KaanLab-Aufträge/Mon. inkl.",
    plan_enterprise_f5: "Priorisierter 24/7-Support",
    plan_enterprise_f6: "Team-Verwaltung",
    plan_enterprise_f7: "Individuelles Branding",
  },
  fr: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — Analyse approfondie avec des milliers d'agents",
    dr_intro_desc: "Donnez une grande tâche. L'essaim d'agents spécialisés de KaanLab travaille en 10 phases et vous livre un rapport professionnel.",
    dr_agents_in_pool: "Agents experts",
    dr_phases: "Phases",
    dr_delivery: "Livraison",
    dr_pricing_note: "Prix unique par tâche : {price} (~65 TL d'opérations LLM + orchestration multi-phases KaanLab). La tâche démarre après le paiement.",
    dr_get_started: "Commencer",
    dr_pick_domain: "Choisir un domaine",
    dr_pick_domain_desc: "Choisissez la spécialité qui correspond le mieux à votre tâche",
    dr_domain_market: "Analyse de marché",
    dr_domain_market_desc: "SWOT, concurrents, consommateurs, tendances, prix",
    dr_domain_academic: "Recherche académique",
    dr_domain_academic_desc: "Revue de littérature, méthodologie, citations",
    dr_domain_business: "Business plan & investissement",
    dr_domain_business_desc: "Modèle financier, valorisation, pitch deck",
    dr_domain_creative: "Projet créatif",
    dr_domain_creative_desc: "Marque, histoire, personnage, scénario",
    dr_domain_technical: "Analyse technique approfondie",
    dr_domain_technical_desc: "Architecture, comparaison technologique, sécurité",
    dr_task_prompt: "Décrivez votre tâche aussi précisément que possible",
    dr_task_placeholder: "Exemple : Analysez le marché turc des véhicules électriques pour 2026 : acteurs clés, comportement des consommateurs, réglementations, projection sur 3 ans, opportunités et risques...",
    dr_task_too_short: "Écrivez au moins 20 caractères",
    dr_task_ok: "Prêt",
    dr_pay_and_start: "Payer & démarrer ({price})",
    dr_start_free_admin: "Démarrer gratuitement (Admin)",
    dr_payment_failed: "Le paiement n'a pas pu démarrer",
    dr_error: "Une erreur s'est produite",
    dr_job_started: "Tâche KaanLab démarrée !",
    dr_job_title: "Tâche KaanLab",
    dr_progress: "Progression",
    dr_agents_short: "agents",
    dr_report_ready: "Rapport prêt !",
    dr_download_failed: "Échec du téléchargement",
    dr_job_failed: "Échec de la tâche",
    dr_queued: "En file d'attente",
    dr_running: "En cours",
    dr_completed: "Terminé",
    dr_failed: "Échoué",
    dr_cancelled: "Annulé",
    dr_job_resume: "Reprendre",
    dr_job_resumed: "Reprise là où elle s'est arrêtée…",
    dr_job_resume_hint: "Cette tâche a été annulée. Les phases terminées sont conservées ; vous pouvez reprendre là où elle s'est arrêtée.",
    dr_phase_discovery: "1. Découverte",
    dr_phase_landscape: "2. Panorama",
    dr_phase_deepdive: "3. Analyse approfondie",
    dr_phase_data: "4. Données & preuves",
    dr_phase_stakeholder: "5. Points de vue des parties prenantes",
    dr_phase_verify: "6. Vérification",
    dr_phase_risk: "7. Risque & opportunité",
    dr_phase_strategy: "8. Stratégie & recommandations",
    dr_phase_synthesis: "9. Synthèse",
    dr_phase_editorial: "10. Édition",
    dr_planner_decision: "Décision du planificateur IA",
    dr_complexity_simple: "Simple",
    dr_complexity_medium: "Moyen",
    dr_complexity_complex: "Complexe",
    dr_complexity_enterprise: "Niveau entreprise",
    dr_gdocs_note: "Importez le fichier Word dans Google Docs (conversion automatique)",
    dr_leaderboard_title: "Classement des agents",
    dr_leaderboard_desc: "Agents les plus utilisés dans les tâches KaanLab",
    dr_leaderboard_calls: "appels",
    dr_leaderboard_unique: "agents uniques utilisés",
    dr_jobs_history_title: "Mes tâches",
    dr_jobs_history_desc: "Vos tâches KaanLab passées",
    dr_jobs_total: "tâches",
    dr_no_jobs_yet: "Aucune tâche pour l'instant",
    dr_no_jobs_hint: "Cliquez sur le bouton 🌊 pour démarrer votre première tâche KaanLab",
    custom_agents_title: "Mes agents personnalisés",
    custom_agents_desc: "Ajoutez vos propres agents spécialisés aux tâches KaanLab (max 20)",
    custom_agents_slot: "emplacements utilisés",
    custom_agents_empty: "Aucun agent personnalisé pour l'instant",
    custom_agents_empty_hint: "Cliquez sur Nouvel agent pour définir votre spécialiste",
    custom_agent_new: "Nouvel agent",
    custom_agent_name: "Nom",
    custom_agent_role: "Rôle",
    custom_agent_domain: "Domaine",
    custom_agent_phase: "Phase",
    custom_agent_prompt: "Prompt système (comment cet agent doit-il se comporter ?)",
    custom_agent_save: "Enregistrer",
    custom_agent_created: "Agent créé",
    custom_agent_error: "Échec de l'opération sur l'agent",
    custom_agent_validation: "Nom min. 2 caractères, prompt min. 20 caractères",
    custom_agent_delete_confirm: "Supprimer cet agent personnalisé ?",
    dr_job_delete_confirm: "Supprimer cette tâche ? Le rapport sera perdu à jamais.",
    dr_job_deleted: "Tâche supprimée",
    dr_job_rerun: "Relancer",
    dr_job_rerun_started: "Tâche relancée",
    dr_challenger_mode: "⚡ Mode Challenger — remettre en question les conclusions",
    dr_challenger_started: "Rapport Challenger démarré — génération de contre-arguments",
    dr_job_cancel: "Annuler",
    dr_job_cancel_confirm: "Annuler cette tâche ? Elle s'arrêtera et le rapport ne sera pas terminé.",
    dr_job_cancelled: "Tâche annulée",
    dr_share: "Partager",
    dr_shared_ok: "Rapport partagé",
    dr_shared_copied: "Rapport copié dans le presse-papiers 📋",
    dr_share_failed: "Échec du partage",
    quota_msg_daily_warm: "Belle discussion aujourd'hui ! 💜",
    quota_msg_daily_warm_desc: "Vous avez utilisé vos messages gratuits du jour. Que diriez-vous d'un forfait pour des discussions illimitées ?",
    quota_upgrade_cta: "Voir les forfaits",
    delete: "Supprimer",
    cancel: "Annuler",
    coming_soon: "bientôt disponible",
    back: "Retour",
    loading: "Chargement...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 crédits/mois",
    plan_enterprise_f2: "Accès IA illimité",
    plan_enterprise_f3: "Accès API",
    plan_enterprise_f4: "5 tâches KaanLab/mois incluses",
    plan_enterprise_f5: "Support prioritaire 24/7",
    plan_enterprise_f6: "Gestion d'équipe",
    plan_enterprise_f7: "Personnalisation de marque",
  },
  es: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — Análisis profundo con miles de agentes",
    dr_intro_desc: "Dé una tarea grande. El enjambre de agentes especialistas de KaanLab trabaja en 10 fases y le entrega un informe profesional.",
    dr_agents_in_pool: "Agentes expertos",
    dr_phases: "Fases",
    dr_delivery: "Entrega",
    dr_pricing_note: "Precio único por tarea: {price} (~65 TL de operaciones LLM + orquestación multifase de KaanLab). La tarea comienza tras el pago.",
    dr_get_started: "Comenzar",
    dr_pick_domain: "Elegir un dominio",
    dr_pick_domain_desc: "Elija la especialidad que mejor se adapte a su tarea",
    dr_domain_market: "Análisis de mercado",
    dr_domain_market_desc: "DAFO, competidores, consumidores, tendencias, precios",
    dr_domain_academic: "Investigación académica",
    dr_domain_academic_desc: "Revisión bibliográfica, metodología, citas",
    dr_domain_business: "Plan de negocio e inversión",
    dr_domain_business_desc: "Modelo financiero, valoración, pitch deck",
    dr_domain_creative: "Proyecto creativo",
    dr_domain_creative_desc: "Marca, historia, personaje, guion",
    dr_domain_technical: "Análisis técnico profundo",
    dr_domain_technical_desc: "Arquitectura, comparación tecnológica, seguridad",
    dr_task_prompt: "Describa su tarea con el mayor detalle posible",
    dr_task_placeholder: "Ejemplo: Analice el mercado turco de vehículos eléctricos para 2026: actores clave, comportamiento del consumidor, regulaciones, proyección a 3 años, oportunidades y riesgos...",
    dr_task_too_short: "Escriba al menos 20 caracteres",
    dr_task_ok: "Listo",
    dr_pay_and_start: "Pagar y empezar ({price})",
    dr_start_free_admin: "Empezar gratis (Admin)",
    dr_payment_failed: "No se pudo iniciar el pago",
    dr_error: "Ocurrió un error",
    dr_job_started: "¡Trabajo de KaanLab iniciado!",
    dr_job_title: "Trabajo de KaanLab",
    dr_progress: "Progreso",
    dr_agents_short: "agentes",
    dr_report_ready: "¡Informe listo!",
    dr_download_failed: "Error al descargar",
    dr_job_failed: "El trabajo falló",
    dr_queued: "En cola",
    dr_running: "En curso",
    dr_completed: "Completado",
    dr_failed: "Fallido",
    dr_cancelled: "Cancelado",
    dr_job_resume: "Reanudar",
    dr_job_resumed: "Reanudando desde donde se detuvo…",
    dr_job_resume_hint: "Este trabajo fue cancelado. Las fases completadas se conservan; puede continuar desde donde se detuvo.",
    dr_phase_discovery: "1. Descubrimiento",
    dr_phase_landscape: "2. Panorama",
    dr_phase_deepdive: "3. Análisis profundo",
    dr_phase_data: "4. Datos y evidencia",
    dr_phase_stakeholder: "5. Perspectivas de las partes interesadas",
    dr_phase_verify: "6. Verificación",
    dr_phase_risk: "7. Riesgo y oportunidad",
    dr_phase_strategy: "8. Estrategia y recomendaciones",
    dr_phase_synthesis: "9. Síntesis",
    dr_phase_editorial: "10. Edición",
    dr_planner_decision: "Decisión del planificador de IA",
    dr_complexity_simple: "Simple",
    dr_complexity_medium: "Medio",
    dr_complexity_complex: "Complejo",
    dr_complexity_enterprise: "Nivel empresarial",
    dr_gdocs_note: "Suba el archivo Word a Google Docs (conversión automática)",
    dr_leaderboard_title: "Clasificación de agentes",
    dr_leaderboard_desc: "Agentes más usados en trabajos de KaanLab",
    dr_leaderboard_calls: "llamadas",
    dr_leaderboard_unique: "agentes únicos usados",
    dr_jobs_history_title: "Mis trabajos",
    dr_jobs_history_desc: "Sus trabajos anteriores de KaanLab",
    dr_jobs_total: "trabajos",
    dr_no_jobs_yet: "Aún no hay trabajos",
    dr_no_jobs_hint: "Haga clic en el botón 🌊 para iniciar su primer trabajo de KaanLab",
    custom_agents_title: "Mis agentes personalizados",
    custom_agents_desc: "Agregue sus propios agentes especializados a los trabajos de KaanLab (máx. 20)",
    custom_agents_slot: "espacios usados",
    custom_agents_empty: "Aún no hay agentes personalizados",
    custom_agents_empty_hint: "Haga clic en Nuevo agente para definir su especialista",
    custom_agent_new: "Nuevo agente",
    custom_agent_name: "Nombre",
    custom_agent_role: "Rol",
    custom_agent_domain: "Dominio",
    custom_agent_phase: "Fase",
    custom_agent_prompt: "Prompt del sistema (¿cómo debe comportarse este agente?)",
    custom_agent_save: "Guardar",
    custom_agent_created: "Agente creado",
    custom_agent_error: "La operación del agente falló",
    custom_agent_validation: "Nombre mín. 2 caracteres, prompt mín. 20 caracteres",
    custom_agent_delete_confirm: "¿Eliminar este agente personalizado?",
    dr_job_delete_confirm: "¿Eliminar este trabajo? El informe se perderá para siempre.",
    dr_job_deleted: "Trabajo eliminado",
    dr_job_rerun: "Volver a ejecutar",
    dr_job_rerun_started: "Trabajo reiniciado",
    dr_challenger_mode: "⚡ Modo Challenger — cuestionar los hallazgos",
    dr_challenger_started: "Informe Challenger iniciado — generando contraargumentos",
    dr_job_cancel: "Cancelar",
    dr_job_cancel_confirm: "¿Cancelar este trabajo? Se detendrá y el informe no se completará.",
    dr_job_cancelled: "Trabajo cancelado",
    dr_share: "Compartir",
    dr_shared_ok: "Informe compartido",
    dr_shared_copied: "Informe copiado al portapapeles 📋",
    dr_share_failed: "Error al compartir",
    quota_msg_daily_warm: "¡Buena charla hoy! 💜",
    quota_msg_daily_warm_desc: "Has usado tus mensajes gratuitos diarios. ¿Qué tal un plan para chats ilimitados?",
    quota_upgrade_cta: "Ver planes",
    delete: "Eliminar",
    cancel: "Cancelar",
    coming_soon: "próximamente",
    back: "Atrás",
    loading: "Cargando...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 créditos/mes",
    plan_enterprise_f2: "Acceso ilimitado a IA",
    plan_enterprise_f3: "Acceso API",
    plan_enterprise_f4: "5 trabajos KaanLab/mes incluidos",
    plan_enterprise_f5: "Soporte prioritario 24/7",
    plan_enterprise_f6: "Gestión de equipos",
    plan_enterprise_f7: "Marca personalizada",
  },
  ar: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — تحليل معمّق بآلاف الوكلاء",
    dr_intro_desc: "أعطِ مهمة كبيرة. يعمل سرب الوكلاء المتخصصين في KaanLab عبر 10 مراحل ويقدّم لك تقريرًا احترافيًا.",
    dr_agents_in_pool: "وكلاء خبراء",
    dr_phases: "المراحل",
    dr_delivery: "التسليم",
    dr_pricing_note: "سعر المهمة لمرة واحدة: {price} (~65 ليرة تركية من عمليات LLM + تنسيق KaanLab متعدد المراحل). تبدأ المهمة بعد الدفع.",
    dr_get_started: "ابدأ",
    dr_pick_domain: "اختر مجالًا",
    dr_pick_domain_desc: "اختر التخصص الأنسب لمهمتك",
    dr_domain_market: "تحليل السوق",
    dr_domain_market_desc: "SWOT، المنافسون، المستهلكون، الاتجاهات، التسعير",
    dr_domain_academic: "بحث أكاديمي",
    dr_domain_academic_desc: "مراجعة الأدبيات، المنهجية، الاستشهادات",
    dr_domain_business: "خطة عمل واستثمار",
    dr_domain_business_desc: "نموذج مالي، تقييم، عرض تقديمي",
    dr_domain_creative: "مشروع إبداعي",
    dr_domain_creative_desc: "علامة تجارية، قصة، شخصية، سيناريو",
    dr_domain_technical: "تحليل تقني معمّق",
    dr_domain_technical_desc: "البنية، مقارنة التقنيات، الأمان",
    dr_task_prompt: "صف مهمتك بأكبر قدر ممكن من التفاصيل",
    dr_task_placeholder: "مثال: حلّل سوق السيارات الكهربائية في تركيا لعام 2026: اللاعبون الرئيسيون، سلوك المستهلك، اللوائح، توقعات 3 سنوات، الفرص والمخاطر...",
    dr_task_too_short: "اكتب 20 حرفًا على الأقل",
    dr_task_ok: "جاهز",
    dr_pay_and_start: "ادفع وابدأ ({price})",
    dr_start_free_admin: "ابدأ مجانًا (مسؤول)",
    dr_payment_failed: "تعذّر بدء الدفع",
    dr_error: "حدث خطأ",
    dr_job_started: "بدأت مهمة KaanLab!",
    dr_job_title: "مهمة KaanLab",
    dr_progress: "التقدّم",
    dr_agents_short: "وكلاء",
    dr_report_ready: "التقرير جاهز!",
    dr_download_failed: "فشل التنزيل",
    dr_job_failed: "فشلت المهمة",
    dr_queued: "في قائمة الانتظار",
    dr_running: "قيد التشغيل",
    dr_completed: "مكتمل",
    dr_failed: "فشل",
    dr_cancelled: "أُلغي",
    dr_job_resume: "استئناف",
    dr_job_resumed: "الاستئناف من حيث توقّف…",
    dr_job_resume_hint: "أُلغيت هذه المهمة. المراحل المكتملة محفوظة؛ يمكنك المتابعة من حيث توقّفت.",
    dr_phase_discovery: "1. الاستكشاف",
    dr_phase_landscape: "2. النظرة العامة",
    dr_phase_deepdive: "3. التحليل المعمّق",
    dr_phase_data: "4. البيانات والأدلة",
    dr_phase_stakeholder: "5. وجهات نظر الأطراف المعنية",
    dr_phase_verify: "6. التحقّق",
    dr_phase_risk: "7. المخاطر والفرص",
    dr_phase_strategy: "8. الاستراتيجية والتوصيات",
    dr_phase_synthesis: "9. التركيب",
    dr_phase_editorial: "10. التحرير",
    dr_planner_decision: "قرار مخطّط الذكاء الاصطناعي",
    dr_complexity_simple: "بسيط",
    dr_complexity_medium: "متوسط",
    dr_complexity_complex: "معقّد",
    dr_complexity_enterprise: "مستوى مؤسسي",
    dr_gdocs_note: "ارفع ملف Word إلى Google Docs (تحويل تلقائي)",
    dr_leaderboard_title: "لوحة صدارة الوكلاء",
    dr_leaderboard_desc: "الوكلاء الأكثر استخدامًا في مهام KaanLab",
    dr_leaderboard_calls: "استدعاءات",
    dr_leaderboard_unique: "وكلاء فريدون مُستخدمون",
    dr_jobs_history_title: "مهامي",
    dr_jobs_history_desc: "مهام KaanLab السابقة الخاصة بك",
    dr_jobs_total: "مهام",
    dr_no_jobs_yet: "لا توجد مهام بعد",
    dr_no_jobs_hint: "انقر على زر 🌊 لبدء أول مهمة KaanLab",
    custom_agents_title: "وكلائي المخصّصون",
    custom_agents_desc: "أضف وكلاءك المتخصصين إلى مهام KaanLab (بحد أقصى 20)",
    custom_agents_slot: "الخانات المستخدمة",
    custom_agents_empty: "لا يوجد وكلاء مخصّصون بعد",
    custom_agents_empty_hint: "انقر على وكيل جديد لتعريف متخصّصك",
    custom_agent_new: "وكيل جديد",
    custom_agent_name: "الاسم",
    custom_agent_role: "الدور",
    custom_agent_domain: "المجال",
    custom_agent_phase: "المرحلة",
    custom_agent_prompt: "موجّه النظام (كيف يجب أن يتصرّف هذا الوكيل؟)",
    custom_agent_save: "حفظ",
    custom_agent_created: "تم إنشاء الوكيل",
    custom_agent_error: "فشلت عملية الوكيل",
    custom_agent_validation: "الاسم حرفان على الأقل، الموجّه 20 حرفًا على الأقل",
    custom_agent_delete_confirm: "حذف هذا الوكيل المخصّص؟",
    dr_job_delete_confirm: "حذف هذه المهمة؟ سيُفقد التقرير للأبد.",
    dr_job_deleted: "تم حذف المهمة",
    dr_job_rerun: "إعادة التشغيل",
    dr_job_rerun_started: "أُعيد تشغيل المهمة",
    dr_challenger_mode: "⚡ وضع التحدّي — تحدَّ النتائج",
    dr_challenger_started: "بدأ تقرير التحدّي — يجري توليد الحجج المضادة",
    dr_job_cancel: "إلغاء",
    dr_job_cancel_confirm: "إلغاء هذه المهمة؟ ستتوقّف ولن يكتمل التقرير.",
    dr_job_cancelled: "أُلغيت المهمة",
    dr_share: "مشاركة",
    dr_shared_ok: "تمت مشاركة التقرير",
    dr_shared_copied: "تم نسخ التقرير إلى الحافظة 📋",
    dr_share_failed: "فشلت المشاركة",
    quota_msg_daily_warm: "دردشة رائعة اليوم! 💜",
    quota_msg_daily_warm_desc: "لقد استخدمت رسائلك اليومية المجانية. ما رأيك بخطة للدردشة غير المحدودة؟",
    quota_upgrade_cta: "عرض الخطط",
    delete: "حذف",
    cancel: "إلغاء",
    coming_soon: "قريبًا",
    back: "رجوع",
    loading: "جارٍ التحميل...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 رصيد/شهر",
    plan_enterprise_f2: "وصول غير محدود للذكاء الاصطناعي",
    plan_enterprise_f3: "وصول API",
    plan_enterprise_f4: "5 مهام KaanLab/شهر مضمّنة",
    plan_enterprise_f5: "دعم أولوية 24/7",
    plan_enterprise_f6: "إدارة الفريق",
    plan_enterprise_f7: "علامة تجارية مخصّصة",
  },
  ru: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — глубокий анализ с тысячами агентов",
    dr_intro_desc: "Поставьте крупную задачу. Рой специализированных агентов KaanLab работает в 10 фазах и выдаёт профессиональный отчёт.",
    dr_agents_in_pool: "Агенты-эксперты",
    dr_phases: "Фазы",
    dr_delivery: "Доставка",
    dr_pricing_note: "Разовая цена задачи: {price} (~65 TL операций LLM + многофазная оркестрация KaanLab). Задача начинается после оплаты.",
    dr_get_started: "Начать",
    dr_pick_domain: "Выберите область",
    dr_pick_domain_desc: "Выберите специализацию, наиболее подходящую для вашей задачи",
    dr_domain_market: "Анализ рынка",
    dr_domain_market_desc: "SWOT, конкуренты, потребители, тренды, ценообразование",
    dr_domain_academic: "Академическое исследование",
    dr_domain_academic_desc: "Обзор литературы, методология, цитирование",
    dr_domain_business: "Бизнес-план и инвестиции",
    dr_domain_business_desc: "Финансовая модель, оценка, питч-дек",
    dr_domain_creative: "Творческий проект",
    dr_domain_creative_desc: "Бренд, история, персонаж, сценарий",
    dr_domain_technical: "Глубокий технический анализ",
    dr_domain_technical_desc: "Архитектура, сравнение технологий, безопасность",
    dr_task_prompt: "Опишите вашу задачу как можно подробнее",
    dr_task_placeholder: "Пример: Проанализируйте рынок электромобилей Турции на 2026 год: ключевые игроки, поведение потребителей, регулирование, прогноз на 3 года, возможности и риски...",
    dr_task_too_short: "Напишите не менее 20 символов",
    dr_task_ok: "Готово",
    dr_pay_and_start: "Оплатить и начать ({price})",
    dr_start_free_admin: "Начать бесплатно (Админ)",
    dr_payment_failed: "Не удалось начать оплату",
    dr_error: "Произошла ошибка",
    dr_job_started: "Задача KaanLab запущена!",
    dr_job_title: "Задача KaanLab",
    dr_progress: "Прогресс",
    dr_agents_short: "агентов",
    dr_report_ready: "Отчёт готов!",
    dr_download_failed: "Ошибка загрузки",
    dr_job_failed: "Задача не выполнена",
    dr_queued: "В очереди",
    dr_running: "Выполняется",
    dr_completed: "Завершено",
    dr_failed: "Не удалось",
    dr_cancelled: "Отменено",
    dr_job_resume: "Продолжить",
    dr_job_resumed: "Продолжение с места остановки…",
    dr_job_resume_hint: "Эта задача была отменена. Завершённые фазы сохранены; вы можете продолжить с места остановки.",
    dr_phase_discovery: "1. Разведка",
    dr_phase_landscape: "2. Обзор",
    dr_phase_deepdive: "3. Глубокий анализ",
    dr_phase_data: "4. Данные и доказательства",
    dr_phase_stakeholder: "5. Взгляды заинтересованных сторон",
    dr_phase_verify: "6. Проверка",
    dr_phase_risk: "7. Риски и возможности",
    dr_phase_strategy: "8. Стратегия и рекомендации",
    dr_phase_synthesis: "9. Синтез",
    dr_phase_editorial: "10. Редактура",
    dr_planner_decision: "Решение ИИ-планировщика",
    dr_complexity_simple: "Простой",
    dr_complexity_medium: "Средний",
    dr_complexity_complex: "Сложный",
    dr_complexity_enterprise: "Корпоративный уровень",
    dr_gdocs_note: "Загрузите файл Word в Google Docs (автоконвертация)",
    dr_leaderboard_title: "Рейтинг агентов",
    dr_leaderboard_desc: "Самые используемые агенты в задачах KaanLab",
    dr_leaderboard_calls: "вызовов",
    dr_leaderboard_unique: "уникальных агентов использовано",
    dr_jobs_history_title: "Мои задачи",
    dr_jobs_history_desc: "Ваши прошлые задачи KaanLab",
    dr_jobs_total: "задач",
    dr_no_jobs_yet: "Пока нет задач",
    dr_no_jobs_hint: "Нажмите кнопку 🌊, чтобы запустить свою первую задачу KaanLab",
    custom_agents_title: "Мои пользовательские агенты",
    custom_agents_desc: "Добавьте своих специализированных агентов в задачи KaanLab (макс. 20)",
    custom_agents_slot: "слотов использовано",
    custom_agents_empty: "Пока нет пользовательских агентов",
    custom_agents_empty_hint: "Нажмите Новый агент, чтобы задать своего специалиста",
    custom_agent_new: "Новый агент",
    custom_agent_name: "Имя",
    custom_agent_role: "Роль",
    custom_agent_domain: "Область",
    custom_agent_phase: "Фаза",
    custom_agent_prompt: "Системный промпт (как должен вести себя этот агент?)",
    custom_agent_save: "Сохранить",
    custom_agent_created: "Агент создан",
    custom_agent_error: "Операция с агентом не удалась",
    custom_agent_validation: "Имя минимум 2 символа, промпт минимум 20 символов",
    custom_agent_delete_confirm: "Удалить этого пользовательского агента?",
    dr_job_delete_confirm: "Удалить эту задачу? Отчёт будет потерян навсегда.",
    dr_job_deleted: "Задача удалена",
    dr_job_rerun: "Перезапустить",
    dr_job_rerun_started: "Задача перезапущена",
    dr_challenger_mode: "⚡ Режим Challenger — оспорить выводы",
    dr_challenger_started: "Отчёт Challenger запущен — генерируются контраргументы",
    dr_job_cancel: "Отменить",
    dr_job_cancel_confirm: "Отменить эту задачу? Она остановится, и отчёт не будет завершён.",
    dr_job_cancelled: "Задача отменена",
    dr_share: "Поделиться",
    dr_shared_ok: "Отчёт отправлен",
    dr_shared_copied: "Отчёт скопирован в буфер обмена 📋",
    dr_share_failed: "Не удалось поделиться",
    quota_msg_daily_warm: "Отличная беседа сегодня! 💜",
    quota_msg_daily_warm_desc: "Вы использовали свои бесплатные сообщения на сегодня. Как насчёт тарифа для безлимитных чатов?",
    quota_upgrade_cta: "Посмотреть тарифы",
    delete: "Удалить",
    cancel: "Отмена",
    coming_soon: "скоро",
    back: "Назад",
    loading: "Загрузка...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 кредитов/мес",
    plan_enterprise_f2: "Безлимитный доступ к ИИ",
    plan_enterprise_f3: "Доступ к API",
    plan_enterprise_f4: "5 задач KaanLab/мес включено",
    plan_enterprise_f5: "Приоритетная поддержка 24/7",
    plan_enterprise_f6: "Управление командой",
    plan_enterprise_f7: "Индивидуальный брендинг",
  },
  zh: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — 数千智能体深度分析",
    dr_intro_desc: "提出一个大任务。KaanLab 的专家智能体群将分 10 个阶段工作，为您生成一份专业报告。",
    dr_agents_in_pool: "专家智能体",
    dr_phases: "阶段",
    dr_delivery: "交付",
    dr_pricing_note: "单次任务价格：{price}（约 65 TL 的 LLM 操作 + KaanLab 多阶段编排）。付款后任务开始。",
    dr_get_started: "开始",
    dr_pick_domain: "选择领域",
    dr_pick_domain_desc: "选择最适合您任务的专业方向",
    dr_domain_market: "市场分析",
    dr_domain_market_desc: "SWOT、竞争对手、消费者、趋势、定价",
    dr_domain_academic: "学术研究",
    dr_domain_academic_desc: "文献综述、方法论、引用",
    dr_domain_business: "商业计划与投资",
    dr_domain_business_desc: "财务模型、估值、路演材料",
    dr_domain_creative: "创意项目",
    dr_domain_creative_desc: "品牌、故事、角色、剧本",
    dr_domain_technical: "技术深度剖析",
    dr_domain_technical_desc: "架构、技术对比、安全",
    dr_task_prompt: "尽可能详细地描述您的任务",
    dr_task_placeholder: "示例：分析 2026 年土耳其电动汽车市场：主要参与者、消费者行为、法规、三年预测、机遇与风险……",
    dr_task_too_short: "请至少输入 20 个字符",
    dr_task_ok: "就绪",
    dr_pay_and_start: "支付并开始（{price}）",
    dr_start_free_admin: "免费开始（管理员）",
    dr_payment_failed: "无法开始支付",
    dr_error: "发生错误",
    dr_job_started: "KaanLab 任务已开始！",
    dr_job_title: "KaanLab 任务",
    dr_progress: "进度",
    dr_agents_short: "个智能体",
    dr_report_ready: "报告已就绪！",
    dr_download_failed: "下载失败",
    dr_job_failed: "任务失败",
    dr_queued: "排队中",
    dr_running: "运行中",
    dr_completed: "已完成",
    dr_failed: "失败",
    dr_cancelled: "已取消",
    dr_job_resume: "继续",
    dr_job_resumed: "正在从停止处继续……",
    dr_job_resume_hint: "此任务已取消。已完成的阶段会保留；您可以从停止处继续。",
    dr_phase_discovery: "1. 探索",
    dr_phase_landscape: "2. 概览",
    dr_phase_deepdive: "3. 深度分析",
    dr_phase_data: "4. 数据与证据",
    dr_phase_stakeholder: "5. 利益相关者视角",
    dr_phase_verify: "6. 验证",
    dr_phase_risk: "7. 风险与机遇",
    dr_phase_strategy: "8. 策略与建议",
    dr_phase_synthesis: "9. 综合",
    dr_phase_editorial: "10. 编辑",
    dr_planner_decision: "AI 规划器决策",
    dr_complexity_simple: "简单",
    dr_complexity_medium: "中等",
    dr_complexity_complex: "复杂",
    dr_complexity_enterprise: "企业级",
    dr_gdocs_note: "将 Word 文件上传到 Google Docs（自动转换）",
    dr_leaderboard_title: "智能体排行榜",
    dr_leaderboard_desc: "KaanLab 任务中使用最多的智能体",
    dr_leaderboard_calls: "次调用",
    dr_leaderboard_unique: "个独立智能体已使用",
    dr_jobs_history_title: "我的任务",
    dr_jobs_history_desc: "您过去的 KaanLab 任务",
    dr_jobs_total: "个任务",
    dr_no_jobs_yet: "暂无任务",
    dr_no_jobs_hint: "点击 🌊 按钮开始您的第一个 KaanLab 任务",
    custom_agents_title: "我的自定义智能体",
    custom_agents_desc: "将您自己的专业智能体添加到 KaanLab 任务（最多 20 个）",
    custom_agents_slot: "已用槽位",
    custom_agents_empty: "暂无自定义智能体",
    custom_agents_empty_hint: "点击新建智能体以定义您的专家",
    custom_agent_new: "新建智能体",
    custom_agent_name: "名称",
    custom_agent_role: "角色",
    custom_agent_domain: "领域",
    custom_agent_phase: "阶段",
    custom_agent_prompt: "系统提示词（该智能体应如何行动？）",
    custom_agent_save: "保存",
    custom_agent_created: "智能体已创建",
    custom_agent_error: "智能体操作失败",
    custom_agent_validation: "名称至少 2 个字符，提示词至少 20 个字符",
    custom_agent_delete_confirm: "删除此自定义智能体？",
    dr_job_delete_confirm: "删除此任务？报告将永久丢失。",
    dr_job_deleted: "任务已删除",
    dr_job_rerun: "重新运行",
    dr_job_rerun_started: "任务已重新开始",
    dr_challenger_mode: "⚡ 挑战者模式 — 质疑结论",
    dr_challenger_started: "挑战者报告已开始 — 正在生成反驳论点",
    dr_job_cancel: "取消",
    dr_job_cancel_confirm: "取消此任务？它将停止且报告不会完成。",
    dr_job_cancelled: "任务已取消",
    dr_share: "分享",
    dr_shared_ok: "报告已分享",
    dr_shared_copied: "报告已复制到剪贴板 📋",
    dr_share_failed: "分享失败",
    quota_msg_daily_warm: "今天聊得很愉快！💜",
    quota_msg_daily_warm_desc: "您已用完今日的免费消息。要不要选择一个套餐畅聊无限？",
    quota_upgrade_cta: "查看套餐",
    delete: "删除",
    cancel: "取消",
    coming_soon: "即将推出",
    back: "返回",
    loading: "加载中……",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 积分/月",
    plan_enterprise_f2: "无限 AI 访问",
    plan_enterprise_f3: "API 访问",
    plan_enterprise_f4: "含 5 个 KaanLab 任务/月",
    plan_enterprise_f5: "优先 24/7 支持",
    plan_enterprise_f6: "团队管理",
    plan_enterprise_f7: "自定义品牌",
  },
  ja: {
    dr_nav_button: "KaanLab",
    dr_title: "KaanLab — 数千のエージェントによる詳細分析",
    dr_intro_desc: "大きなタスクを与えてください。KaanLab の専門エージェント群が 10 のフェーズで作業し、プロフェッショナルなレポートを提供します。",
    dr_agents_in_pool: "専門エージェント",
    dr_phases: "フェーズ",
    dr_delivery: "納品",
    dr_pricing_note: "タスク単発価格：{price}（LLM 処理 約65TL + KaanLab マルチフェーズ・オーケストレーション）。支払い後にタスクが開始します。",
    dr_get_started: "始める",
    dr_pick_domain: "ドメインを選択",
    dr_pick_domain_desc: "タスクに最も適した専門分野を選んでください",
    dr_domain_market: "市場分析",
    dr_domain_market_desc: "SWOT、競合、消費者、トレンド、価格設定",
    dr_domain_academic: "学術研究",
    dr_domain_academic_desc: "文献レビュー、方法論、引用",
    dr_domain_business: "事業計画・投資",
    dr_domain_business_desc: "財務モデル、評価、ピッチデック",
    dr_domain_creative: "クリエイティブ・プロジェクト",
    dr_domain_creative_desc: "ブランド、ストーリー、キャラクター、脚本",
    dr_domain_technical: "技術ディープダイブ",
    dr_domain_technical_desc: "アーキテクチャ、技術比較、セキュリティ",
    dr_task_prompt: "タスクをできるだけ詳しく説明してください",
    dr_task_placeholder: "例：2026 年のトルコの EV 市場を分析：主要プレイヤー、消費者行動、規制、3 年予測、機会とリスク……",
    dr_task_too_short: "20 文字以上入力してください",
    dr_task_ok: "準備完了",
    dr_pay_and_start: "支払って開始（{price}）",
    dr_start_free_admin: "無料で開始（管理者）",
    dr_payment_failed: "支払いを開始できませんでした",
    dr_error: "エラーが発生しました",
    dr_job_started: "KaanLab ジョブを開始しました！",
    dr_job_title: "KaanLab ジョブ",
    dr_progress: "進捗",
    dr_agents_short: "エージェント",
    dr_report_ready: "レポートの準備ができました！",
    dr_download_failed: "ダウンロードに失敗しました",
    dr_job_failed: "ジョブが失敗しました",
    dr_queued: "待機中",
    dr_running: "実行中",
    dr_completed: "完了",
    dr_failed: "失敗",
    dr_cancelled: "キャンセル済み",
    dr_job_resume: "再開",
    dr_job_resumed: "停止した箇所から再開しています…",
    dr_job_resume_hint: "このジョブはキャンセルされました。完了したフェーズは保持されます。停止した箇所から続行できます。",
    dr_phase_discovery: "1. 探索",
    dr_phase_landscape: "2. 全体像",
    dr_phase_deepdive: "3. 深掘り",
    dr_phase_data: "4. データと根拠",
    dr_phase_stakeholder: "5. ステークホルダーの視点",
    dr_phase_verify: "6. 検証",
    dr_phase_risk: "7. リスクと機会",
    dr_phase_strategy: "8. 戦略と提言",
    dr_phase_synthesis: "9. 統合",
    dr_phase_editorial: "10. 編集",
    dr_planner_decision: "AI プランナーの判断",
    dr_complexity_simple: "シンプル",
    dr_complexity_medium: "中程度",
    dr_complexity_complex: "複雑",
    dr_complexity_enterprise: "エンタープライズ級",
    dr_gdocs_note: "Word ファイルを Google Docs にアップロード（自動変換）",
    dr_leaderboard_title: "エージェント・リーダーボード",
    dr_leaderboard_desc: "KaanLab ジョブで最も使われたエージェント",
    dr_leaderboard_calls: "回の呼び出し",
    dr_leaderboard_unique: "個のユニークなエージェントを使用",
    dr_jobs_history_title: "マイジョブ",
    dr_jobs_history_desc: "過去の KaanLab ジョブ",
    dr_jobs_total: "件のジョブ",
    dr_no_jobs_yet: "まだジョブがありません",
    dr_no_jobs_hint: "🌊 ボタンをクリックして最初の KaanLab ジョブを開始",
    custom_agents_title: "マイ・カスタムエージェント",
    custom_agents_desc: "独自の専門エージェントを KaanLab ジョブに追加（最大 20）",
    custom_agents_slot: "使用中のスロット",
    custom_agents_empty: "カスタムエージェントはまだありません",
    custom_agents_empty_hint: "新規エージェントをクリックして専門家を定義してください",
    custom_agent_new: "新規エージェント",
    custom_agent_name: "名前",
    custom_agent_role: "役割",
    custom_agent_domain: "ドメイン",
    custom_agent_phase: "フェーズ",
    custom_agent_prompt: "システムプロンプト（このエージェントはどう振る舞うべき？）",
    custom_agent_save: "保存",
    custom_agent_created: "エージェントを作成しました",
    custom_agent_error: "エージェント操作に失敗しました",
    custom_agent_validation: "名前は 2 文字以上、プロンプトは 20 文字以上",
    custom_agent_delete_confirm: "このカスタムエージェントを削除しますか？",
    dr_job_delete_confirm: "このジョブを削除しますか？レポートは永久に失われます。",
    dr_job_deleted: "ジョブを削除しました",
    dr_job_rerun: "再実行",
    dr_job_rerun_started: "ジョブを再開しました",
    dr_challenger_mode: "⚡ チャレンジャーモード — 結論に挑戦",
    dr_challenger_started: "チャレンジャーレポート開始 — 反論を生成中",
    dr_job_cancel: "キャンセル",
    dr_job_cancel_confirm: "このジョブをキャンセルしますか？停止し、レポートは完成しません。",
    dr_job_cancelled: "ジョブをキャンセルしました",
    dr_share: "共有",
    dr_shared_ok: "レポートを共有しました",
    dr_shared_copied: "レポートをクリップボードにコピーしました 📋",
    dr_share_failed: "共有に失敗しました",
    quota_msg_daily_warm: "今日はたくさん話せました！💜",
    quota_msg_daily_warm_desc: "本日の無料メッセージを使い切りました。無制限チャットのプランはいかがですか？",
    quota_upgrade_cta: "プランを見る",
    delete: "削除",
    cancel: "キャンセル",
    coming_soon: "近日公開",
    back: "戻る",
    loading: "読み込み中...",
    plan_enterprise_monthly: "Pro Enterprise",
    plan_enterprise_f1: "5000 クレジット/月",
    plan_enterprise_f2: "無制限の AI アクセス",
    plan_enterprise_f3: "API アクセス",
    plan_enterprise_f4: "5 KaanLab ジョブ/月 込み",
    plan_enterprise_f5: "優先 24/7 サポート",
    plan_enterprise_f6: "チーム管理",
    plan_enterprise_f7: "カスタムブランディング",
  }
};

// Apply DR translations per-language (each language now has its own full block).
Object.keys(deepResearchTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], deepResearchTranslations[lang]);
  }
});

// Subscription, Memory, Credit packages translations
const planMemoryTranslations = {
  tr: {
    // Subscription / Plans
    plan_starter_monthly: "Başlangıç Aylık",
    plan_pro_monthly: "Standart Aylık",
    plan_premium_monthly: "Premium Aylık",
    plan_starter_f1: "200 kredi/ay",
    plan_starter_f2: "Temel AI özellikleri",
    plan_starter_f3: "E-posta desteği",
    plan_pro_f1: "500 kredi/ay",
    plan_pro_f2: "Tüm AI özellikleri",
    plan_pro_f3: "Öncelikli destek",
    plan_pro_f4: "Görsel analiz",
    plan_premium_f1: "1500 kredi/ay",
    plan_premium_f2: "Sınırsız AI erişimi",
    plan_premium_f3: "7/24 destek",
    plan_premium_f4: "API erişimi",
    plan_premium_f5: "Özel özellikler",
    package_starter: "Başlangıç Paketi",
    package_pro: "Pro Paket",
    package_premium: "Premium Paket",
    choose_plan: "Bir plan seçin:",
    cancel_subscription: "İptal Et",
    credits_per_month: "kredi/ay",
    per_month_short: "ay",
    // Memory panel
    extract_from_chat_desc: "Bu sohbetten anılarınızı çıkarın ve kaydedin",
    extract_save: "Çıkar ve Kaydet",
    facts_label: "Hakkımdaki Bilgiler",
    interests_label: "İlgi Alanlarım",
    add_fact: "Yeni bilgi ekle...",
    add_interest: "Yeni ilgi alanı ekle...",
    no_facts_yet: "Henüz bilgi eklenmedi",
    no_interests_yet: "Henüz ilgi alanı eklenmedi",
    last_topics: "Son Konuşulan Konular",
    clear_memory: "Tüm Hafızayı Temizle",
    // RAG
    rag_title: "Belge Tabanı (RAG)",
    rag_desc: "Belgelerinizi yükleyin, AI sohbet sırasında bu belgeleri kullansın.",
    upload_document: "Belge Yükle",
    documents: "Belgeler",
    no_documents_yet: "Henüz belge yüklenmedi"
  },
  en: {
    plan_starter_monthly: "Starter Monthly",
    plan_pro_monthly: "Standard Monthly",
    plan_premium_monthly: "Premium Monthly",
    plan_starter_f1: "200 credits/month",
    plan_starter_f2: "Basic AI features",
    plan_starter_f3: "Email support",
    plan_pro_f1: "500 credits/month",
    plan_pro_f2: "All AI features",
    plan_pro_f3: "Priority support",
    plan_pro_f4: "Image analysis",
    plan_premium_f1: "1500 credits/month",
    plan_premium_f2: "Unlimited AI access",
    plan_premium_f3: "24/7 support",
    plan_premium_f4: "API access",
    plan_premium_f5: "Exclusive features",
    package_starter: "Starter Package",
    package_pro: "Pro Package",
    package_premium: "Premium Package",
    choose_plan: "Choose a plan:",
    cancel_subscription: "Cancel Subscription",
    credits_per_month: "credits/month",
    per_month_short: "mo",
    extract_from_chat_desc: "Extract memories from this conversation and save them",
    extract_save: "Extract & Save",
    facts_label: "Facts About Me",
    interests_label: "My Interests",
    add_fact: "Add a new fact...",
    add_interest: "Add a new interest...",
    no_facts_yet: "No facts added yet",
    no_interests_yet: "No interests added yet",
    last_topics: "Recent Topics",
    clear_memory: "Clear All Memory",
    rag_title: "Document Knowledge (RAG)",
    rag_desc: "Upload your documents and let the AI use them during chat.",
    upload_document: "Upload Document",
    documents: "Documents",
    no_documents_yet: "No documents uploaded yet"
  },
  de: {
    plan_starter_monthly: "Starter Monatlich",
    plan_pro_monthly: "Standard Monatlich",
    plan_premium_monthly: "Premium Monatlich",
    plan_starter_f1: "200 Credits/Monat",
    plan_starter_f2: "Grundlegende KI-Funktionen",
    plan_starter_f3: "E-Mail-Support",
    plan_pro_f1: "500 Credits/Monat",
    plan_pro_f2: "Alle KI-Funktionen",
    plan_pro_f3: "Priority-Support",
    plan_pro_f4: "Bildanalyse",
    plan_premium_f1: "1500 Credits/Monat",
    plan_premium_f2: "Unbegrenzter KI-Zugriff",
    plan_premium_f3: "24/7 Support",
    plan_premium_f4: "API-Zugriff",
    plan_premium_f5: "Exklusive Funktionen",
    package_starter: "Starter-Paket",
    package_pro: "Pro-Paket",
    package_premium: "Premium-Paket",
    choose_plan: "Wählen Sie einen Plan:",
    cancel_subscription: "Abonnement kündigen",
    credits_per_month: "Credits/Monat",
    per_month_short: "Mo",
    extract_from_chat_desc: "Erinnerungen aus diesem Gespräch extrahieren und speichern",
    extract_save: "Extrahieren & Speichern",
    facts_label: "Fakten über mich",
    interests_label: "Meine Interessen",
    add_fact: "Neuen Fakt hinzufügen...",
    add_interest: "Neues Interesse hinzufügen...",
    no_facts_yet: "Noch keine Fakten hinzugefügt",
    no_interests_yet: "Noch keine Interessen hinzugefügt",
    last_topics: "Letzte Themen",
    clear_memory: "Gesamten Speicher löschen",
    rag_title: "Dokumenten-Wissen (RAG)",
    rag_desc: "Laden Sie Ihre Dokumente hoch und lassen Sie die KI sie im Chat verwenden.",
    upload_document: "Dokument hochladen",
    documents: "Dokumente",
    no_documents_yet: "Noch keine Dokumente hochgeladen"
  },
  fr: {
    plan_starter_monthly: "Starter Mensuel",
    plan_pro_monthly: "Pro Mensuel",
    plan_premium_monthly: "Premium Mensuel",
    plan_starter_f1: "200 crédits/mois",
    plan_starter_f2: "Fonctionnalités IA de base",
    plan_starter_f3: "Support par e-mail",
    plan_pro_f1: "500 crédits/mois",
    plan_pro_f2: "Toutes les fonctionnalités IA",
    plan_pro_f3: "Support prioritaire",
    plan_pro_f4: "Analyse d'image",
    plan_premium_f1: "1500 crédits/mois",
    plan_premium_f2: "Accès IA illimité",
    plan_premium_f3: "Support 24/7",
    plan_premium_f4: "Accès API",
    plan_premium_f5: "Fonctionnalités exclusives",
    package_starter: "Pack Starter",
    package_pro: "Pack Pro",
    package_premium: "Pack Premium",
    choose_plan: "Choisissez un plan :",
    cancel_subscription: "Annuler l'abonnement",
    credits_per_month: "crédits/mois",
    per_month_short: "mo",
    extract_from_chat_desc: "Extraire les souvenirs de cette conversation et les enregistrer",
    extract_save: "Extraire et enregistrer",
    facts_label: "Faits à mon sujet",
    interests_label: "Mes centres d'intérêt",
    add_fact: "Ajouter un nouveau fait...",
    add_interest: "Ajouter un nouvel intérêt...",
    no_facts_yet: "Aucun fait ajouté pour le moment",
    no_interests_yet: "Aucun intérêt ajouté pour le moment",
    last_topics: "Sujets récents",
    clear_memory: "Effacer toute la mémoire",
    rag_title: "Connaissance documentaire (RAG)",
    rag_desc: "Téléchargez vos documents et laissez l'IA les utiliser pendant la conversation.",
    upload_document: "Télécharger un document",
    documents: "Documents",
    no_documents_yet: "Aucun document téléchargé"
  },
  es: {
    plan_starter_monthly: "Starter Mensual",
    plan_pro_monthly: "Estándar Mensual",
    plan_premium_monthly: "Premium Mensual",
    plan_starter_f1: "200 créditos/mes",
    plan_starter_f2: "Funciones básicas de IA",
    plan_starter_f3: "Soporte por correo",
    plan_pro_f1: "500 créditos/mes",
    plan_pro_f2: "Todas las funciones de IA",
    plan_pro_f3: "Soporte prioritario",
    plan_pro_f4: "Análisis de imágenes",
    plan_premium_f1: "1500 créditos/mes",
    plan_premium_f2: "Acceso ilimitado a IA",
    plan_premium_f3: "Soporte 24/7",
    plan_premium_f4: "Acceso a API",
    plan_premium_f5: "Funciones exclusivas",
    package_starter: "Paquete Starter",
    package_pro: "Paquete Pro",
    package_premium: "Paquete Premium",
    choose_plan: "Elige un plan:",
    cancel_subscription: "Cancelar suscripción",
    credits_per_month: "créditos/mes",
    per_month_short: "mes",
    extract_from_chat_desc: "Extraer recuerdos de esta conversación y guardarlos",
    extract_save: "Extraer y guardar",
    facts_label: "Datos sobre mí",
    interests_label: "Mis intereses",
    add_fact: "Añadir un nuevo dato...",
    add_interest: "Añadir un nuevo interés...",
    no_facts_yet: "Aún no se han añadido datos",
    no_interests_yet: "Aún no se han añadido intereses",
    last_topics: "Temas recientes",
    clear_memory: "Borrar toda la memoria",
    rag_title: "Conocimiento documental (RAG)",
    rag_desc: "Sube tus documentos y deja que la IA los use durante el chat.",
    upload_document: "Subir documento",
    documents: "Documentos",
    no_documents_yet: "Aún no se han subido documentos"
  },
  ar: {
    plan_starter_monthly: "المبتدئ الشهري",
    plan_pro_monthly: "Pro الشهري",
    plan_premium_monthly: "Premium الشهري",
    plan_starter_f1: "200 رصيد/شهر",
    plan_starter_f2: "ميزات الذكاء الاصطناعي الأساسية",
    plan_starter_f3: "دعم بالبريد الإلكتروني",
    plan_pro_f1: "500 رصيد/شهر",
    plan_pro_f2: "جميع ميزات الذكاء الاصطناعي",
    plan_pro_f3: "دعم بالأولوية",
    plan_pro_f4: "تحليل الصور",
    plan_premium_f1: "1500 رصيد/شهر",
    plan_premium_f2: "وصول غير محدود للذكاء الاصطناعي",
    plan_premium_f3: "دعم 24/7",
    plan_premium_f4: "وصول إلى API",
    plan_premium_f5: "ميزات حصرية",
    package_starter: "حزمة المبتدئ",
    package_pro: "حزمة Pro",
    package_premium: "حزمة Premium",
    choose_plan: "اختر خطة:",
    cancel_subscription: "إلغاء الاشتراك",
    credits_per_month: "رصيد/شهر",
    per_month_short: "شهر",
    extract_from_chat_desc: "استخراج الذكريات من هذه المحادثة وحفظها",
    extract_save: "استخراج وحفظ",
    facts_label: "حقائق عني",
    interests_label: "اهتماماتي",
    add_fact: "أضف حقيقة جديدة...",
    add_interest: "أضف اهتمامًا جديدًا...",
    no_facts_yet: "لم تتم إضافة حقائق بعد",
    no_interests_yet: "لم تتم إضافة اهتمامات بعد",
    last_topics: "المواضيع الأخيرة",
    clear_memory: "مسح كل الذاكرة",
    rag_title: "قاعدة المعرفة (RAG)",
    rag_desc: "ارفع مستنداتك ودع الذكاء الاصطناعي يستخدمها أثناء المحادثة.",
    upload_document: "رفع مستند",
    documents: "المستندات",
    no_documents_yet: "لم يتم رفع مستندات بعد"
  },
  ru: {
    plan_starter_monthly: "Starter Месячный",
    plan_pro_monthly: "Стандарт Месячный",
    plan_premium_monthly: "Premium Месячный",
    plan_starter_f1: "200 кредитов/мес",
    plan_starter_f2: "Базовые функции ИИ",
    plan_starter_f3: "Поддержка по email",
    plan_pro_f1: "500 кредитов/мес",
    plan_pro_f2: "Все функции ИИ",
    plan_pro_f3: "Приоритетная поддержка",
    plan_pro_f4: "Анализ изображений",
    plan_premium_f1: "1500 кредитов/мес",
    plan_premium_f2: "Безлимитный доступ к ИИ",
    plan_premium_f3: "Поддержка 24/7",
    plan_premium_f4: "Доступ к API",
    plan_premium_f5: "Эксклюзивные функции",
    package_starter: "Стартовый пакет",
    package_pro: "Pro пакет",
    package_premium: "Premium пакет",
    choose_plan: "Выберите план:",
    cancel_subscription: "Отменить подписку",
    credits_per_month: "кредитов/мес",
    per_month_short: "мес",
    extract_from_chat_desc: "Извлечь воспоминания из этого разговора и сохранить",
    extract_save: "Извлечь и сохранить",
    facts_label: "Факты обо мне",
    interests_label: "Мои интересы",
    add_fact: "Добавить новый факт...",
    add_interest: "Добавить новый интерес...",
    no_facts_yet: "Факты пока не добавлены",
    no_interests_yet: "Интересы пока не добавлены",
    last_topics: "Последние темы",
    clear_memory: "Очистить всю память",
    rag_title: "База знаний (RAG)",
    rag_desc: "Загрузите свои документы, и ИИ будет использовать их во время чата.",
    upload_document: "Загрузить документ",
    documents: "Документы",
    no_documents_yet: "Документы пока не загружены"
  },
  zh: {
    plan_starter_monthly: "入门月度",
    plan_pro_monthly: "标准月度",
    plan_premium_monthly: "高级月度",
    plan_starter_f1: "200 积分/月",
    plan_starter_f2: "基础 AI 功能",
    plan_starter_f3: "邮件支持",
    plan_pro_f1: "500 积分/月",
    plan_pro_f2: "全部 AI 功能",
    plan_pro_f3: "优先支持",
    plan_pro_f4: "图像分析",
    plan_premium_f1: "1500 积分/月",
    plan_premium_f2: "无限 AI 访问",
    plan_premium_f3: "24/7 支持",
    plan_premium_f4: "API 访问",
    plan_premium_f5: "独家功能",
    package_starter: "入门套餐",
    package_pro: "专业套餐",
    package_premium: "高级套餐",
    choose_plan: "选择一个计划:",
    cancel_subscription: "取消订阅",
    credits_per_month: "积分/月",
    per_month_short: "月",
    extract_from_chat_desc: "从此对话中提取记忆并保存",
    extract_save: "提取并保存",
    facts_label: "关于我的事实",
    interests_label: "我的兴趣",
    add_fact: "添加新事实...",
    add_interest: "添加新兴趣...",
    no_facts_yet: "尚未添加事实",
    no_interests_yet: "尚未添加兴趣",
    last_topics: "最近话题",
    clear_memory: "清除所有记忆",
    rag_title: "文档知识 (RAG)",
    rag_desc: "上传您的文档，让 AI 在聊天时使用它们。",
    upload_document: "上传文档",
    documents: "文档",
    no_documents_yet: "尚未上传文档"
  },
  ja: {
    plan_starter_monthly: "スターター月額",
    plan_pro_monthly: "スタンダード月額",
    plan_premium_monthly: "プレミアム月額",
    plan_starter_f1: "200 クレジット/月",
    plan_starter_f2: "基本 AI 機能",
    plan_starter_f3: "メールサポート",
    plan_pro_f1: "500 クレジット/月",
    plan_pro_f2: "すべての AI 機能",
    plan_pro_f3: "優先サポート",
    plan_pro_f4: "画像分析",
    plan_premium_f1: "1500 クレジット/月",
    plan_premium_f2: "無制限 AI アクセス",
    plan_premium_f3: "24/7 サポート",
    plan_premium_f4: "API アクセス",
    plan_premium_f5: "限定機能",
    package_starter: "スターターパッケージ",
    package_pro: "プロパッケージ",
    package_premium: "プレミアムパッケージ",
    choose_plan: "プランを選択:",
    cancel_subscription: "サブスクリプションをキャンセル",
    credits_per_month: "クレジット/月",
    per_month_short: "月",
    extract_from_chat_desc: "この会話から記憶を抽出して保存",
    extract_save: "抽出して保存",
    facts_label: "私についての事実",
    interests_label: "私の興味",
    add_fact: "新しい事実を追加...",
    add_interest: "新しい興味を追加...",
    no_facts_yet: "事実はまだ追加されていません",
    no_interests_yet: "興味はまだ追加されていません",
    last_topics: "最近のトピック",
    clear_memory: "すべての記憶をクリア",
    rag_title: "ドキュメントナレッジ (RAG)",
    rag_desc: "ドキュメントをアップロードして、AI がチャット中に使用できるようにします。",
    upload_document: "ドキュメントをアップロード",
    documents: "ドキュメント",
    no_documents_yet: "ドキュメントはまだアップロードされていません"
  }
};

Object.keys(planMemoryTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], planMemoryTranslations[lang]);
  }
});

// Birthday label translations (used by MemoryPanel)
const birthdayTranslations = {
  tr: { birthday: "Doğum Günü" },
  en: { birthday: "Birthday" },
  de: { birthday: "Geburtstag" },
  fr: { birthday: "Anniversaire" },
  es: { birthday: "Cumpleaños" },
  ar: { birthday: "عيد الميلاد" },
  ru: { birthday: "День рождения" },
  zh: { birthday: "生日" },
  ja: { birthday: "誕生日" }
};
Object.keys(birthdayTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], birthdayTranslations[lang]);
  }
});

// Sidebar dialog translations (rename + share)
const sidebarDialogs = {
  tr: {
    rename_chat_title: "Sohbet İsmini Değiştir",
    new_name_placeholder: "Yeni isim...",
    share_chat_title: "Sohbeti Paylaş",
    share_chat_desc: "Bu linki paylaşarak sohbeti başkalarıyla paylaşabilirsiniz."
  },
  en: {
    rename_chat_title: "Rename Chat",
    new_name_placeholder: "New name...",
    share_chat_title: "Share Chat",
    share_chat_desc: "Share this link to let others view this chat."
  },
  de: {
    rename_chat_title: "Chat umbenennen",
    new_name_placeholder: "Neuer Name...",
    share_chat_title: "Chat teilen",
    share_chat_desc: "Teilen Sie diesen Link, damit andere den Chat sehen können."
  },
  fr: {
    rename_chat_title: "Renommer la conversation",
    new_name_placeholder: "Nouveau nom...",
    share_chat_title: "Partager la conversation",
    share_chat_desc: "Partagez ce lien pour que d'autres puissent voir cette conversation."
  },
  es: {
    rename_chat_title: "Renombrar chat",
    new_name_placeholder: "Nuevo nombre...",
    share_chat_title: "Compartir chat",
    share_chat_desc: "Comparta este enlace para que otros puedan ver este chat."
  },
  ar: {
    rename_chat_title: "إعادة تسمية المحادثة",
    new_name_placeholder: "اسم جديد...",
    share_chat_title: "مشاركة المحادثة",
    share_chat_desc: "شارك هذا الرابط للسماح للآخرين بعرض هذه المحادثة."
  },
  ru: {
    rename_chat_title: "Переименовать чат",
    new_name_placeholder: "Новое имя...",
    share_chat_title: "Поделиться чатом",
    share_chat_desc: "Поделитесь этой ссылкой, чтобы другие могли увидеть этот чат."
  },
  zh: {
    rename_chat_title: "重命名对话",
    new_name_placeholder: "新名称...",
    share_chat_title: "分享对话",
    share_chat_desc: "分享此链接，让他人查看此对话。"
  },
  ja: {
    rename_chat_title: "チャット名を変更",
    new_name_placeholder: "新しい名前...",
    share_chat_title: "チャットを共有",
    share_chat_desc: "このリンクを共有して他の人がチャットを見られるようにします。"
  }
};

Object.keys(sidebarDialogs).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], sidebarDialogs[lang]);
  }
});

// Assistant creator translations
const assistantCreator = {
  tr: {
    assistant_gender: "Cinsiyet",
    assistant_voice: "Ses",
    assistant_communication_style: "Konuşma Tarzı",
    assistant_personality_def: "Kişilik Tanımı",
    assistant_prompt_placeholder: "Asistanın kişiliğini, konuşma tarzını ve uzmanlık alanlarını tanımlayın...",
    characters: "karakter",
    gender_male: "Erkek",
    gender_female: "Kadın",
    gender_neutral: "Nötr",
    style_formal: "Saygılı/Resmi",
    style_formal_desc: "\"Siz\" ile hitap, profesyonel dil",
    style_normal: "Normal Samimi",
    style_normal_desc: "\"Sen\" ile hitap ama aşırı samimi değil",
    style_adaptive: "Kullanıcıya Uyumlu",
    style_adaptive_desc: "Kullanıcının tarzına göre uyum sağlar",
    style_friendly: "Çok Samimi",
    style_friendly_desc: "Kanka, canım gibi samimi hitaplar"
  },
  en: {
    assistant_gender: "Gender",
    assistant_voice: "Voice",
    assistant_communication_style: "Communication Style",
    assistant_personality_def: "Personality Definition",
    assistant_prompt_placeholder: "Define the assistant's personality, communication style and areas of expertise...",
    characters: "characters",
    gender_male: "Male",
    gender_female: "Female",
    gender_neutral: "Neutral",
    style_formal: "Respectful/Formal",
    style_formal_desc: "Formal address, professional language",
    style_normal: "Normal Casual",
    style_normal_desc: "Casual address but not too friendly",
    style_adaptive: "User-Adaptive",
    style_adaptive_desc: "Adapts to the user's style",
    style_friendly: "Very Friendly",
    style_friendly_desc: "Buddy, dude-style intimate address"
  },
  de: {
    assistant_gender: "Geschlecht",
    assistant_voice: "Stimme",
    assistant_communication_style: "Kommunikationsstil",
    assistant_personality_def: "Persönlichkeitsdefinition",
    assistant_prompt_placeholder: "Definieren Sie die Persönlichkeit, den Kommunikationsstil und die Fachgebiete des Assistenten...",
    characters: "Zeichen",
    gender_male: "Männlich",
    gender_female: "Weiblich",
    gender_neutral: "Neutral",
    style_formal: "Respektvoll/Formal",
    style_formal_desc: "Formelle Anrede, professionelle Sprache",
    style_normal: "Normal Locker",
    style_normal_desc: "Lockere Anrede, aber nicht zu freundschaftlich",
    style_adaptive: "Benutzerangepasst",
    style_adaptive_desc: "Passt sich dem Stil des Benutzers an",
    style_friendly: "Sehr Freundlich",
    style_friendly_desc: "Kumpelhafte, vertraute Anrede"
  },
  fr: {
    assistant_gender: "Genre",
    assistant_voice: "Voix",
    assistant_communication_style: "Style de communication",
    assistant_personality_def: "Définition de la personnalité",
    assistant_prompt_placeholder: "Définissez la personnalité, le style de communication et les domaines d'expertise de l'assistant...",
    characters: "caractères",
    gender_male: "Homme",
    gender_female: "Femme",
    gender_neutral: "Neutre",
    style_formal: "Respectueux/Formel",
    style_formal_desc: "Adresse formelle, langage professionnel",
    style_normal: "Normal Décontracté",
    style_normal_desc: "Adresse décontractée mais pas trop amicale",
    style_adaptive: "Adaptatif",
    style_adaptive_desc: "S'adapte au style de l'utilisateur",
    style_friendly: "Très amical",
    style_friendly_desc: "Adresse intime et amicale"
  },
  es: {
    assistant_gender: "Género",
    assistant_voice: "Voz",
    assistant_communication_style: "Estilo de comunicación",
    assistant_personality_def: "Definición de personalidad",
    assistant_prompt_placeholder: "Defina la personalidad, el estilo de comunicación y las áreas de experiencia del asistente...",
    characters: "caracteres",
    gender_male: "Masculino",
    gender_female: "Femenino",
    gender_neutral: "Neutro",
    style_formal: "Respetuoso/Formal",
    style_formal_desc: "Trato formal, lenguaje profesional",
    style_normal: "Normal Casual",
    style_normal_desc: "Trato casual pero no demasiado amigable",
    style_adaptive: "Adaptable",
    style_adaptive_desc: "Se adapta al estilo del usuario",
    style_friendly: "Muy amigable",
    style_friendly_desc: "Trato íntimo y amistoso"
  },
  ar: {
    assistant_gender: "الجنس",
    assistant_voice: "الصوت",
    assistant_communication_style: "أسلوب التواصل",
    assistant_personality_def: "تعريف الشخصية",
    assistant_prompt_placeholder: "حدد شخصية المساعد وأسلوب تواصله ومجالات خبرته...",
    characters: "حرف",
    gender_male: "ذكر",
    gender_female: "أنثى",
    gender_neutral: "محايد",
    style_formal: "محترم/رسمي",
    style_formal_desc: "خطاب رسمي، لغة احترافية",
    style_normal: "عادي ودود",
    style_normal_desc: "خطاب ودود ولكن ليس حميمًا جدًا",
    style_adaptive: "متكيف مع المستخدم",
    style_adaptive_desc: "يتكيف مع أسلوب المستخدم",
    style_friendly: "ودود جدًا",
    style_friendly_desc: "خطاب حميمي ومألوف"
  },
  ru: {
    assistant_gender: "Пол",
    assistant_voice: "Голос",
    assistant_communication_style: "Стиль общения",
    assistant_personality_def: "Описание личности",
    assistant_prompt_placeholder: "Опишите личность ассистента, стиль общения и области экспертизы...",
    characters: "символов",
    gender_male: "Мужской",
    gender_female: "Женский",
    gender_neutral: "Нейтральный",
    style_formal: "Уважительный/Формальный",
    style_formal_desc: "Формальное обращение, профессиональный язык",
    style_normal: "Обычный Дружелюбный",
    style_normal_desc: "Дружелюбное обращение, но не слишком фамильярное",
    style_adaptive: "Адаптивный",
    style_adaptive_desc: "Подстраивается под стиль пользователя",
    style_friendly: "Очень дружелюбный",
    style_friendly_desc: "Близкое и дружеское обращение"
  },
  zh: {
    assistant_gender: "性别",
    assistant_voice: "声音",
    assistant_communication_style: "沟通风格",
    assistant_personality_def: "性格定义",
    assistant_prompt_placeholder: "定义助手的性格、沟通风格和专业领域...",
    characters: "字符",
    gender_male: "男性",
    gender_female: "女性",
    gender_neutral: "中性",
    style_formal: "尊重/正式",
    style_formal_desc: "正式称呼，专业语言",
    style_normal: "普通随意",
    style_normal_desc: "随意称呼但不过于亲密",
    style_adaptive: "适应用户",
    style_adaptive_desc: "适应用户的风格",
    style_friendly: "非常友好",
    style_friendly_desc: "亲密友好的称呼"
  },
  ja: {
    assistant_gender: "性別",
    assistant_voice: "声",
    assistant_communication_style: "コミュニケーションスタイル",
    assistant_personality_def: "人格定義",
    assistant_prompt_placeholder: "アシスタントの性格、コミュニケーションスタイル、専門分野を定義してください...",
    characters: "文字",
    gender_male: "男性",
    gender_female: "女性",
    gender_neutral: "中性",
    style_formal: "敬意ある/フォーマル",
    style_formal_desc: "丁寧な呼びかけ、プロフェッショナルな言葉遣い",
    style_normal: "普通カジュアル",
    style_normal_desc: "カジュアルな呼びかけだが親しすぎない",
    style_adaptive: "ユーザー適応型",
    style_adaptive_desc: "ユーザーのスタイルに合わせる",
    style_friendly: "とてもフレンドリー",
    style_friendly_desc: "親密で友好的な呼びかけ"
  }
};

Object.keys(assistantCreator).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], assistantCreator[lang]);
  }
});

// ------ Yearly billing plans (20% off) ------
const yearlyPlanTranslations = {
  tr: {
    billing_monthly: "Aylık",
    billing_yearly: "Yıllık",
    save_percent: "%{percent} indirim",
    per_year_short: "yıl",
    per_month_avg_short: "ay eşdeğeri",
    yearly_save_badge: "%20 tasarruf",
    plan_starter_yearly: "Başlangıç Yıllık",
    plan_pro_yearly: "Standart Yıllık",
    plan_premium_yearly: "Premium Yıllık",
    plan_enterprise_yearly: "Pro Enterprise Yıllık",
    plan_yearly_discount_20: "%20 yıllık indirim"
  },
  en: {
    billing_monthly: "Monthly",
    billing_yearly: "Yearly",
    save_percent: "{percent}% off",
    per_year_short: "yr",
    per_month_avg_short: "/mo avg",
    yearly_save_badge: "Save 20%",
    plan_starter_yearly: "Starter Yearly",
    plan_pro_yearly: "Standard Yearly",
    plan_premium_yearly: "Premium Yearly",
    plan_enterprise_yearly: "Pro Enterprise Yearly",
    plan_yearly_discount_20: "20% yearly discount"
  },
  de: {
    billing_monthly: "Monatlich",
    billing_yearly: "Jährlich",
    save_percent: "{percent}% Rabatt",
    per_year_short: "Jahr",
    per_month_avg_short: "/Mo Ø",
    yearly_save_badge: "20% sparen",
    plan_starter_yearly: "Starter Jährlich",
    plan_pro_yearly: "Standard Jährlich",
    plan_premium_yearly: "Premium Jährlich",
    plan_enterprise_yearly: "Pro Enterprise Jährlich",
    plan_yearly_discount_20: "20% Jahresrabatt"
  },
  fr: {
    billing_monthly: "Mensuel",
    billing_yearly: "Annuel",
    save_percent: "{percent}% de réduction",
    per_year_short: "an",
    per_month_avg_short: "/mo équiv.",
    yearly_save_badge: "20% d'économie",
    plan_starter_yearly: "Starter Annuel",
    plan_pro_yearly: "Pro Annuel",
    plan_premium_yearly: "Premium Annuel",
    plan_enterprise_yearly: "Pro Enterprise Annuel",
    plan_yearly_discount_20: "20% de remise annuelle"
  },
  es: {
    billing_monthly: "Mensual",
    billing_yearly: "Anual",
    save_percent: "{percent}% de descuento",
    per_year_short: "año",
    per_month_avg_short: "/mes equiv.",
    yearly_save_badge: "Ahorra 20%",
    plan_starter_yearly: "Starter Anual",
    plan_pro_yearly: "Estándar Anual",
    plan_premium_yearly: "Premium Anual",
    plan_enterprise_yearly: "Pro Enterprise Anual",
    plan_yearly_discount_20: "20% descuento anual"
  },
  ar: {
    billing_monthly: "شهري",
    billing_yearly: "سنوي",
    save_percent: "خصم {percent}%",
    per_year_short: "سنة",
    per_month_avg_short: "/شهر تقريبًا",
    yearly_save_badge: "وفر 20%",
    plan_starter_yearly: "المبتدئ السنوي",
    plan_pro_yearly: "Pro السنوي",
    plan_premium_yearly: "Premium السنوي",
    plan_enterprise_yearly: "Pro Enterprise السنوي",
    plan_yearly_discount_20: "خصم سنوي 20%"
  },
  ru: {
    billing_monthly: "Ежемесячно",
    billing_yearly: "Ежегодно",
    save_percent: "Скидка {percent}%",
    per_year_short: "год",
    per_month_avg_short: "/мес в ср.",
    yearly_save_badge: "Экономия 20%",
    plan_starter_yearly: "Starter Годовой",
    plan_pro_yearly: "Стандарт Годовой",
    plan_premium_yearly: "Premium Годовой",
    plan_enterprise_yearly: "Pro Enterprise Годовой",
    plan_yearly_discount_20: "Годовая скидка 20%"
  },
  zh: {
    billing_monthly: "月付",
    billing_yearly: "年付",
    save_percent: "省 {percent}%",
    per_year_short: "年",
    per_month_avg_short: "/月均",
    yearly_save_badge: "省20%",
    plan_starter_yearly: "入门年度",
    plan_pro_yearly: "标准年度",
    plan_premium_yearly: "高级年度",
    plan_enterprise_yearly: "Pro Enterprise 年度",
    plan_yearly_discount_20: "年付立减20%"
  },
  ja: {
    billing_monthly: "月払い",
    billing_yearly: "年払い",
    save_percent: "{percent}%オフ",
    per_year_short: "年",
    per_month_avg_short: "/月換算",
    yearly_save_badge: "20%お得",
    plan_starter_yearly: "スターター年額",
    plan_pro_yearly: "スタンダード年額",
    plan_premium_yearly: "プレミアム年額",
    plan_enterprise_yearly: "Pro Enterprise 年額",
    plan_yearly_discount_20: "年払い20%割引"
  }
};

Object.keys(yearlyPlanTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], yearlyPlanTranslations[lang]);
  }
});

// ------ Attach "+" menu + ChatGPT-style Voice Mode ------
const voiceAndAttachTranslations = {
  tr: {
    attach: "Ekle",
    attach_photo: "Fotoğraf Yükle",
    attach_generate: "Görsel Oluştur",
    attach_camera: "Kamera",
    attach_file: "Dosya Yükle",
    voice_mode: "Sesli Sohbet",
    voice_status_listening: "Dinliyorum...",
    voice_status_thinking: "Düşünüyorum...",
    voice_status_speaking: "Konuşuyorum...",
    voice_mode_tap_interrupt: "Kesmek için küreye dokun",
    voice_mode_speak_interrupt: "Konuşmaya başla veya küreye dokun",
    scroll_to_bottom: "En alta in",
    voice_tone_auto: "Otomatik",
    voice_tone_friendly: "Samimi",
    voice_tone_balanced: "Dengeli",
    voice_tone_formal: "Resmi",
    voice_label: "Ses",
    voice_preview: "Sesi Dinle",
    voice_detected: "Sesin algılandı",
    voice_awaiting: "Konuş, dinliyorum",
    voice_speed_label: "Hız",
    voice_bargein_label: "Araya gir",
    voice_bargein_on: "Açık",
    voice_bargein_off: "Kapalı",
    voice_change: "Sesi değiştir",
    voice_change_title: "Ses Seç",
    voice_hint_onyx: "Derin erkek",
    voice_hint_nova: "Sıcak kadın",
    voice_hint_shimmer: "Parlak kadın",
    voice_hint_echo: "Nötr",
    voice_hint_fable: "Anlatıcı",
    voice_hint_alloy: "Dengeli",
    stop: "Durdur",
    close: "Kapat"
  },
  en: {
    attach: "Attach",
    attach_photo: "Upload Photo",
    attach_generate: "Generate Image",
    attach_camera: "Camera",
    attach_file: "Upload File",
    voice_mode: "Voice Chat",
    voice_status_listening: "Listening...",
    voice_status_thinking: "Thinking...",
    voice_status_speaking: "Speaking...",
    voice_mode_tap_interrupt: "Tap the orb to interrupt",
    voice_mode_speak_interrupt: "Just start speaking, or tap the orb",
    scroll_to_bottom: "Scroll to latest",
    voice_tone_auto: "Auto",
    voice_tone_friendly: "Friendly",
    voice_tone_balanced: "Balanced",
    voice_tone_formal: "Formal",
    voice_label: "Voice",
    voice_preview: "Preview voice",
    voice_detected: "Voice detected",
    voice_awaiting: "Speak, I'm listening",
    voice_speed_label: "Speed",
    voice_bargein_label: "Interrupt",
    voice_bargein_on: "On",
    voice_bargein_off: "Off",
    voice_change: "Change voice",
    voice_change_title: "Pick a voice",
    voice_hint_onyx: "Deep male",
    voice_hint_nova: "Warm female",
    voice_hint_shimmer: "Bright female",
    voice_hint_echo: "Neutral",
    voice_hint_fable: "Narrator",
    voice_hint_alloy: "Balanced",
    stop: "Stop",
    close: "Close"
  },
  de: {
    attach: "Anhängen",
    attach_photo: "Foto hochladen",
    attach_generate: "Bild generieren",
    attach_camera: "Kamera",
    attach_file: "Datei hochladen",
    voice_mode: "Sprachchat",
    voice_status_listening: "Ich höre zu...",
    voice_status_thinking: "Denke nach...",
    voice_status_speaking: "Ich spreche...",
    voice_mode_tap_interrupt: "Kugel antippen, um zu unterbrechen",
    voice_mode_speak_interrupt: "Einfach sprechen oder Kugel antippen",
    scroll_to_bottom: "Zum Neuesten springen",
    voice_tone_auto: "Automatisch",
    voice_tone_friendly: "Freundlich",
    voice_tone_balanced: "Ausgewogen",
    voice_tone_formal: "Förmlich",
    voice_label: "Stimme",
    voice_preview: "Stimme anhören",
    voice_detected: "Stimme erkannt",
    voice_awaiting: "Sprechen Sie, ich höre",
    voice_speed_label: "Tempo",
    voice_bargein_label: "Unterbrechen",
    voice_bargein_on: "An",
    voice_bargein_off: "Aus",
    stop: "Stopp",
    close: "Schließen"
  },
  fr: {
    attach: "Joindre",
    attach_photo: "Téléverser une photo",
    attach_generate: "Générer une image",
    attach_camera: "Caméra",
    attach_file: "Téléverser un fichier",
    voice_mode: "Chat vocal",
    voice_status_listening: "J'écoute...",
    voice_status_thinking: "Je réfléchis...",
    voice_status_speaking: "Je parle...",
    voice_mode_tap_interrupt: "Touchez l'orbe pour interrompre",
    voice_mode_speak_interrupt: "Parlez simplement ou touchez l'orbe",
    scroll_to_bottom: "Aller au plus récent",
    voice_tone_auto: "Auto",
    voice_tone_friendly: "Amical",
    voice_tone_balanced: "Équilibré",
    voice_tone_formal: "Formel",
    voice_label: "Voix",
    voice_preview: "Écouter la voix",
    voice_detected: "Voix détectée",
    voice_awaiting: "Parlez, j'écoute",
    voice_speed_label: "Vitesse",
    voice_bargein_label: "Interrompre",
    voice_bargein_on: "Activé",
    voice_bargein_off: "Désactivé",
    stop: "Arrêter",
    close: "Fermer"
  },
  es: {
    attach: "Adjuntar",
    attach_photo: "Subir foto",
    attach_generate: "Generar imagen",
    attach_camera: "Cámara",
    attach_file: "Subir archivo",
    voice_mode: "Chat de voz",
    voice_status_listening: "Escuchando...",
    voice_status_thinking: "Pensando...",
    voice_status_speaking: "Hablando...",
    voice_mode_tap_interrupt: "Toca el orbe para interrumpir",
    voice_mode_speak_interrupt: "Solo empieza a hablar o toca el orbe",
    scroll_to_bottom: "Ir a lo más reciente",
    voice_tone_auto: "Auto",
    voice_tone_friendly: "Cercano",
    voice_tone_balanced: "Equilibrado",
    voice_tone_formal: "Formal",
    voice_label: "Voz",
    voice_preview: "Escuchar voz",
    voice_detected: "Voz detectada",
    voice_awaiting: "Habla, te escucho",
    voice_speed_label: "Velocidad",
    voice_bargein_label: "Interrumpir",
    voice_bargein_on: "Activado",
    voice_bargein_off: "Desactivado",
    stop: "Detener",
    close: "Cerrar"
  },
  ar: {
    attach: "إرفاق",
    attach_photo: "تحميل صورة",
    attach_generate: "إنشاء صورة",
    attach_camera: "الكاميرا",
    attach_file: "تحميل ملف",
    voice_mode: "الدردشة الصوتية",
    voice_status_listening: "أستمع...",
    voice_status_thinking: "أفكر...",
    voice_status_speaking: "أتحدث...",
    voice_mode_tap_interrupt: "المس الكرة للمقاطعة",
    voice_mode_speak_interrupt: "ابدأ الكلام فقط أو المس الكرة",
    scroll_to_bottom: "الانتقال إلى الأحدث",
    voice_tone_auto: "تلقائي",
    voice_tone_friendly: "ودّي",
    voice_tone_balanced: "متوازن",
    voice_tone_formal: "رسمي",
    voice_label: "الصوت",
    voice_preview: "استمع للصوت",
    voice_detected: "تم اكتشاف الصوت",
    voice_awaiting: "تحدث، أنا أستمع",
    voice_speed_label: "السرعة",
    voice_bargein_label: "المقاطعة",
    voice_bargein_on: "مفعّل",
    voice_bargein_off: "معطّل",
    stop: "إيقاف",
    close: "إغلاق"
  },
  ru: {
    attach: "Прикрепить",
    attach_photo: "Загрузить фото",
    attach_generate: "Создать изображение",
    attach_camera: "Камера",
    attach_file: "Загрузить файл",
    voice_mode: "Голосовой чат",
    voice_status_listening: "Слушаю...",
    voice_status_thinking: "Думаю...",
    voice_status_speaking: "Говорю...",
    voice_mode_tap_interrupt: "Коснитесь сферы, чтобы прервать",
    voice_mode_speak_interrupt: "Просто начните говорить или коснитесь сферы",
    scroll_to_bottom: "К последним",
    voice_tone_auto: "Авто",
    voice_tone_friendly: "Дружеский",
    voice_tone_balanced: "Сбалансированный",
    voice_tone_formal: "Официальный",
    voice_label: "Голос",
    voice_preview: "Прослушать голос",
    voice_detected: "Голос обнаружен",
    voice_awaiting: "Говорите, я слушаю",
    voice_speed_label: "Скорость",
    voice_bargein_label: "Прерывать",
    voice_bargein_on: "Вкл",
    voice_bargein_off: "Выкл",
    stop: "Стоп",
    close: "Закрыть"
  },
  zh: {
    attach: "附件",
    attach_photo: "上传照片",
    attach_generate: "生成图像",
    attach_camera: "相机",
    attach_file: "上传文件",
    voice_mode: "语音对话",
    voice_status_listening: "正在聆听...",
    voice_status_thinking: "思考中...",
    voice_status_speaking: "正在讲话...",
    voice_mode_tap_interrupt: "点击球体可打断",
    voice_mode_speak_interrupt: "直接说话或点击球体即可打断",
    scroll_to_bottom: "跳到最新",
    voice_tone_auto: "自动",
    voice_tone_friendly: "友好",
    voice_tone_balanced: "平衡",
    voice_tone_formal: "正式",
    voice_label: "语音",
    voice_preview: "试听声音",
    voice_detected: "已检测到声音",
    voice_awaiting: "请讲话，我在听",
    voice_speed_label: "语速",
    voice_bargein_label: "打断",
    voice_bargein_on: "开",
    voice_bargein_off: "关",
    stop: "停止",
    close: "关闭"
  },
  ja: {
    attach: "添付",
    attach_photo: "写真をアップロード",
    attach_generate: "画像を生成",
    attach_camera: "カメラ",
    attach_file: "ファイルをアップロード",
    voice_mode: "音声会話",
    voice_status_listening: "聞いています...",
    voice_status_thinking: "考えています...",
    voice_status_speaking: "話しています...",
    voice_mode_tap_interrupt: "球をタップで割り込み",
    voice_mode_speak_interrupt: "話しかけるか球をタップで割り込み",
    scroll_to_bottom: "最新へ移動",
    voice_tone_auto: "自動",
    voice_tone_friendly: "フレンドリー",
    voice_tone_balanced: "バランス",
    voice_tone_formal: "フォーマル",
    voice_label: "音声",
    voice_preview: "音声を試聴",
    voice_detected: "音声を検出",
    voice_awaiting: "話してください、聞いています",
    voice_speed_label: "速度",
    voice_bargein_label: "割り込み",
    voice_bargein_on: "オン",
    voice_bargein_off: "オフ",
    stop: "停止",
    close: "閉じる"
  }
};

Object.keys(voiceAndAttachTranslations).forEach(lang => {
  if (translations[lang]) {
    Object.assign(translations[lang], voiceAndAttachTranslations[lang]);
  }
});

// Dil hook'u için yardımcı fonksiyon
export const getTranslation = (lang, key, params = {}) => {
  let value = translations[lang]?.[key];

  // Fallback order: for non-Turkish UIs, prefer English before Turkish so that
  // a missing key never leaks Turkish text into a non-Turkish menu.
  if (!value) value = translations['en']?.[key];
  if (!value) value = translations['tr']?.[key];

  if (typeof value === 'string' && Object.keys(params).length > 0) {
    Object.entries(params).forEach(([param, val]) => {
      value = value.replace(`{${param}}`, val);
    });
  }

  return value || key;
};

export default translations;
